import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { usePagination } from '../hooks/usePagination';
import PaginationControls from '../components/PaginationControls';
import EngineeringSlideshowBackground from '../components/EngineeringSlideshowBackground';

const CollegesPage: React.FC = () => {
  const [selectedType, setSelectedType] = useState('All');
  const colleges = [
    // IITs
    
    {
      name: "PSG COLLEGE OF TECHNOLOGY (AUTONOMOUS), PEELAMEDU, COIMBATORE DISTRICT 641004",
      code: "2006",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹9 LPA average",
      type: "Government Aided",
    },
    {
      name: "COIMBATORE INSTITUTE OF TECHNOLOGY (AUTONOMOUS), CIVIL AERODROME POST, COIMBATORE DISTRICT 641014",
      code: "2007",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹7 LPA average",
      type: "Government Aided",
    },
    {
      name: "THIAGARAJAR COLLEGE OF ENGINEERING (AUTONOMOUS), TIRUPPARANKUNDRAM, MADURAI DISTRICT 625015",
      code: "5008",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹6 LPA average",
      type: "Government Aided",
    },
    // Tamil Nadu Colleges
    {
      name: "College of Engineering Guindy (CEG)",
      code: "3002",
      branch: "All Branches",
      location: "Chennai",
      fees: "₹45,000 per year",
      duration: "4 years",
      placement: "₹12 LPA average",
      type: "Anna University Constituent"
    },
    {
      name: "Madras Institute of Technology (MIT)",
      code: "3003",
      branch: "Aerospace",
      location: "Chennai",
      fees: "₹45,000 per year",
      duration: "4 years",
      placement: "₹15 LPA average",
      type: "Anna University Constituent"
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, VILLUPURAM, KAKUPPAM, VILLUPURAM DISTRICT 605103",
      code: "1013",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, TINDIVANAM, MELPAKKAM, TINDIVANAM, VILLUPURAM DISTRICT 604001",
      code: "1014",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, ARNI, ARNI TO DEVIKAPURAM ROAD, THATCHUR, ARNI, THIRUVANNAMALAI DISTRICT 632326",
      code: "1015",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, KANCHEEPURAM, PONNERIKARAI CAMPUS, NH4, CHENNAI-BANGALORE HIGHWAY, KARAIPETTAI VILLAGE POST, KANCHEEPURAM DISTRICT 631552",
      code: "1026",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "ANNA UNIVERSITY REGIONAL CAMPUS - COIMBATORE, MARUTHAMALAI MAIN ROAD, NAVAVOOR BHARATHIYAR UNIVERSITY POST, SOMAYAMPALAYAM, COIMBATORE DISTRICT 641046",
      code: "2025",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹5 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, TIRUCHIRAPPALLI, BHARATHIDASAN INSTITUTE OF TECHNOLOGY, TIRUCHIRAPPALLI DISTRICT 620024",
      code: "3011",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹5 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, ARIYALUR, KATHANKUDIKADU VILLAGE, THELUR POST, ARIYALUR DISTRICT 621704",
      code: "3016",
      branch: "All Branches",
      location: "Ariyalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, THIRUKKUVALAI, NAGAPPATTINAM DISTRICT 610204",
      code: "3018",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, PANRUTI, CHENNAI-KUMBAKONAM HIGHWAY, PANIKKANKUPPAM, PANRUTI, CUDDALORE DISTRICT 607106",
      code: "3019",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, PATTUKKOTTAI, ECR ROAD, RAJAMADAM, PATTUKKOTTAI TALUK, THANJAVUR DISTRICT 614701",
      code: "3021",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "ANNA UNIVERSITY REGIONAL CAMPUS - TIRUNELVELI, TRIVANDRUM ROAD, PALAYAMKOTTAI, TIRUNELVELI DISTRICT 627007",
      code: "4020",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹5 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, NAGERCOIL, NAGERCOIL INDUSTRIAL ESTATE, KONAM, KANYAKUMARI DISTRICT 629004",
      code: "4023",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹4 LPA average",
      type: "Anna University Constituent",
    },
    {
      name: "UNIVERSITY V.O.C. COLLEGE OF ENGINEERING, THOOTHUKUDI, NEAR V.O.C. COLLEGE, MILLERPURAM, THOOTHUKUDI DISTRICT 628008",
      code: "4024",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹3 LPA average",
      type: "Anna University Constituent"
    },
    {
      name: "ANNA UNIVERSITY REGIONAL CAMPUS - MADURAI, KANYAKUMARI NATIONAL HIGHWAY, KEELAKUILKUDI, MADURAI DISTRICT 625019",
      code: "5010",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Anna University Constituent"
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, RAMANATHAPURAM, PULLANGUDI, RAMANATHAPURAM DISTRICT 623513",
      code: "5017",
      branch: "All Branches",
      location: "Ramanathapuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Anna University Constituent"
    },
    {
      name: "UNIVERSITY COLLEGE OF ENGINEERING, DINDIGUL, MANGARAI PIRIVU, REDDIYARCHATHIRAM, DINDIGUL DISTRICT 624622",
      code: "5022",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Anna University Constituent"
    },
    // Central Government Institutions
    {
      name: "Indian Institute of Information Technology (IIIT) Chennai",
      code: "5001",
      branch: "Computer Science",
      location: "Chennai",
      fees: "₹2.2 Lakhs per year",
      duration: "4 years",
      placement: "₹20 LPA average",
      type: "Central Government"
    },
    {
      name: "Defence Institute of Advanced Technology (DIAT)",
      code: "5002",
      branch: "All Branches",
      location: "Pune",
      fees: "₹2.8 Lakhs per year",
      duration: "4 years",
      placement: "₹15 LPA average",
      type: "Central Government"
    },
    {
      name: "Indian Maritime University",
      code: "5003",
      branch: "Marine Engineering",
      location: "Chennai",
      fees: "₹1.5 Lakhs per year",
      duration: "4 years",
      placement: "₹12 LPA average",
      type: "Central Government"
    },
    // Added Central Government entries
    {
      name: "CENTRAL INSTITUTE OF PLASTICS ENGINEERING AND TECHNOLOGY (CIPET), GUINDY, CHENNAI 600032",
      code: "1321",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Central Government"
    },
    {
      name: "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY, FOULKES COMPOUND, THILLAI NAGAR, SALEM DISTRICT 636001",
      code: "2343",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Central Government"
    },
    {
      name: "CENTRAL ELECTROCHEMICAL RESEARCH INSTITUTE (CECRI), KARAIKUDI, SIVAGANGAI DISTRICT 630006",
      code: "5012",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Central Government"
    },
    {
      name: "THIAGARAJAR COLLEGE OF ENGINEERING (AUTONOMOUS), TIRUPPARANKUNDRAM, MADURAI DISTRICT 625015",
      code: "5008",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Government Aided"
    },
    // Engineering Colleges in other states (for diversity)
  
    {
      name: "Delhi Technological University (DTU)",
      code: "6002",
      branch: "All Branches",
      location: "Delhi",
      fees: "₹1.2 Lakhs per year",
      duration: "4 years",
      placement: "₹16 LPA average",
      type: "Government"
    },
    {
      name: "Netaji Subhas University of Technology (NSUT)",
      code: "6003",
      branch: "All Branches",
      location: "Delhi",
      fees: "₹1.1 Lakhs per year",
      duration: "4 years",
      placement: "₹14 LPA average",
      type: "Government"
    },
    {
      name: "Jadavpur University",
      code: "6004",
      branch: "All Branches",
      location: "Kolkata",
      fees: "₹1.5 Lakhs per year",
      duration: "4 years",
      placement: "₹12 LPA average",
      type: "Government"
    },

  
    // New Non-Autonomous Colleges
    {
      name: "AALIM MUHAMMED SALEGH COLLEGE OF ENGINEERING, MUTHAPUDUPET, AVADI IAF, CHENNAI 600055",
      code: "1101",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹3.5 LPA average",
      type: "Non-Autonomous",
    },
    {
      name: "JAYA ENGINEERING COLLEGE, THIRUNINDRAVUR, CHENNAI 602024",
      code: "1106",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹3.5 LPA average",
      type: "Non-Autonomous",
    },
    {
      name: "JAYA INSTITUTE OF TECHNOLOGY, KANCHIPADI POST, THIRUVALLUR-TIRUTTANI NH ROAD, THIRUVALLUR DISTRICT 631204",
      code: "1107",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹3.5 LPA average",
      type: "Non-Autonomous",
    },
    {
      name: "SRIRAM ENGINEERING COLLEGE, PERUMALPATTU, VEPPAMPATTU R S, THIRUVALLUR DISTRICT 602 024",
      code: "1115",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "₹3.2 LPA average",
      type: "Non-Autonomous",
    },
    {
      name: "SRI VENKATESWARA INSTITUTE OF SCIENCE AND TECHNOLOGY, KOZHUNDALUR, THIRUVALLUR DISTRICT 631203",
      code: "1121",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "GOJAN SCHOOL OF BUSINESS AND TECHNOLOGY, ALAMATHI, CHENNAI 600062",
      code: "1123",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SAMS COLLEGE OF ENGINEERING AND TECHNOLOGY, PANAPPAKKAM, CHENNAI-TIRUPATHI ROAD, UTHUKKOTTAI TALUK, THIRUVALLUR DISTRICT 601102",
      code: "1124",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P M R ENGINEERING COLLEGE, ADAYALAMPATTU, MADURAVOYAL , VANAGARAM, CHENNAI 600095",
      code: "1125",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ST. PETERS COLLEGE OF ENGINEERING AND TECHNOLOGY, COLLEGE ROAD, AVADI, CHENNAI 600 054",
      code: "1127",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYA SCHOOL OF ARCHITECTURE, POONAMALLEE BY-PASS ROAD, POONAMALLEE, CHENNAI 600 056",
      code: "1129",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MARG INSTIUTE OF DESIGN & ARCHITECTURE SWARNABHOOMI (MIDAS), MARG SWARNABHOOMI, VELUR VILLAGE, CHEYYUR POST, CHENGALPATTU DISTRICT 603302",
      code: "1130",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RAJALAKSHMI SCHOOL OF ARCHITECTURE, THANDALAM, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1132",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI VEILANKANNIS COLLEGE OF ENGINEERING, GANDHI ROAD, NEDUNGUNDRAM, CHENNAI 600048",
      code: "1133",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AALIM MUHAMMED SALEGH ACADEMY OF ARCHITECTURE, MUTHAPUDUPET, AVADI IAF, CHENNAI 600055",
      code: "1135",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI MIRA COLLEGE OF ENGINEERING AND TECHNOLOGY, ARCOT ROAD, ARAPPAKKAM VILLAGE, WALAJA TAULK, RANIPET DISTRICT 632 517",
      code: "1137",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DAVINCI SCHOOL OF DESIGN AND ARCHITECTURE, KARAPAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600097",
      code: "1138",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JEPPIAAR INSTITUTE OF TECHNOLOGY, KUNNAM VILLAGE, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 631604",
      code: "1140",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "R V S PADMAVATHY COLLEGE OF ENGINEERING AND TECHNOLOGY, SENTHIL PAKKAM VILLAGE, ROSHANAGARAM POST, MADARAPAKKAM VIA, GUMMIDIPOONDI TALUK, THIRUVALLUR DISTRICT 601202",
      code: "1141",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "R V S PADMAVATHY SCHOOL OF ARCHITECTURE, SENTHIL PAKKAM VILLAGE, ROSHANAGARAM POST, MADARAPAKKAM VIA, GUMMIDIPOONDI TALUK, THIRUVALLUR DISTRICT 601202",
      code: "1144",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANAND SCHOOL OF ARCHITECTURE, OLD MAHALIBALIPURAM ROAD (OMR), KAZHIPATTUR, CHENGALPATTU DISTRICT 603103",
      code: "1145",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MISRIMAL NAVAJEE MUNOTH JAIN SCHOOL OF ARCHITECTURE, RAJIV GANDHI SALAI (OMR), THORAIPAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600096",
      code: "1146",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MMES ACADEMY OF ARCHITECTURE, C.ABDUL HAKEEM COLLEGE CAMPUS, HAKEEM NAGAR, MELVISHARAM, RANIPET DISTRICT 632509",
      code: "1147",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI JAYARAM INSTITUTE OF ENGINEERING AND TECHNOLOGY, 51 N, ELAVUR, 58N, NATHAM, GUMMIDIPOONDI TALUK, THIRUVALLUR DISTRICT 601201",
      code: "1150",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CAAD - CHENNAI ACADEMY OF ARCHITECTURE AND DESIGN, NO.24,THUMBAKKAM, CHENNAI-THIRUPATHI HIGHWAY, NEAR PERIYAPALAYAM AMMAN TEMPLE, CHENNAI 601102",
      code: "1152",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAWAHAR SCHOOL OF ARCHITECTURE PLANNING AND DESIGN, NO.54, K K ROAD, SALIGRAMAM, CHENNAI 600093",
      code: "1153",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "LORD VENKATESHWARA ENGINEERING COLLEGE, WALAJABAD POST, KANCHEEPURAM DISTRICT 631605",
      code: "1205",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JEPPIAAR MAAMALLAN ENGINEERING COLLEGE, VADAMANGALAM POST, KANCHEEPURAM DISTRICT 602105",
      code: "1206",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
   
    {
      name: "PALLAVAN COLLEGE OF ENGINEERING, THIMMASAMUDRAM, KANCHEEPURAM DISTRICT 631502",
      code: "1209",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RAJIV GANDHI COLLEGE OF ENGINEERING, NEMILI, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1212",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S K R ENGINEERING COLLEGE, POONAMALLEE, CHENNAI 600123",
      code: "1213",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SAKTHI MARIAMMAN ENGINEERING COLLEGE, NARAYANASAMY NAGAR, THANDALAM, CHENNAI 602105",
      code: "1214",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SREE SASTHA INSTITUTE OF ENGINEERING AND TECHNOLOGY, CHEMBARAMBAKKAM, CHENNAI 600123",
      code: "1217",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
  
    {
      name: "JAYA COLLEGE OF ENGINEERING AND TECHNOLOGY, PARIVAKKAM, POONAMALLEE, CHENNAI 600056",
      code: "1221",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P B COLLEGE OF ENGINEERING, IRUNGKATTUKOTTAI, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1222",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
   
    {
      name: "P T LEE CHENGALVARAYA NAICKER COLLEGE OF ENGINEERING AND TECHNOLOGY, OOVERY, VELIYUR POST, KANCHEEPURAM DISTRICT 631 502",
      code: "1226",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ALPHA COLLEGE OF ENGINEERING, DR. GRACE GEORGE NAGAR, UDAYAVAR KOIL STREET, THIRUMAZHISAI, POONAMALLE, CHENNAI 602107",
      code: "1228",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "INDIRA INSTITUTE OF ENGINEERING AND TECHNOLOGY, VGR GARDENS, PANDUR, THIRUVALLUR DISTRICT 631203",
      code: "1229",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "APOLLO ENGINEERING COLLEGE, MEVALOORKUPPAM, VALARPURAM POST, SRIPERUMPUDUR, KANCHEEPURAM DISTRICT 602105",
      code: "1230",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    
    {
      name: "A R M COLLEGE OF ENGINEERING AND TECHNOLOGY, SATTAMANGALAM, MARAIMALAINAGAR, CHENGALPATTU DISTRICT 603209",
      code: "1232",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    
    {
      name: "JEI MATHAAJEE COLLEGE OF ENGINEERING, VISHAKANDIKUPAM VILLAGE, KANCHEEPURAM DISTRICT 631552",
      code: "1235",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VELAMMAL INSTITUTE OF TECHNOLOGY, CHENNAI-KOLKATTA HIGHWAY, PANCHETTI VILLAGE, PONNERI TALUK, THIRUVALLUR DISTRICT 601204",
      code: "1237",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "T J S ENGINEERING COLLEGE, PERUVOYAL, NEAR KAVARAIPETTAI, GUMMIDIPOONDI TALUK, THIRUVALLUR DISTRICT 601206",
      code: "1241",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MADHA INSTITUTE OF ENGINEERING AND TECHNOLOGY, ERANDAMKATTALAI VILLAGE, SADHANANTHAPURAM, THANDALAM POST, CHENNAI 602101",
      code: "1243",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JEPPIAR ENGINEERING COLLEGE, OLD MAHABALIPURAM ROAD (OMR), CHENGALPATTU DISTRICT, CHENNAI 600119",
      code: "1306",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MEASI ACADEMY OF ARCHITECTURE, ROYAPETTAH, CHENNAI 600 014",
      code: "1308",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MISRIMAL NAVAJEE MUNOTH JAIN ENGINEERING COLLEGE, RAJIV GANDHI SALAI (OMR), THORAPPAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600096",
      code: "1310",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SMK FOMRA INSTITUTE OF TECHNOLOGY,FOMRA NAGAR, OMR,(IT EXPRESS HIGHWAY),KELAMBAKKAM, CHENGALPATTU DISTRICT, CHENNAI- 603103",
      code: "1313",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "T J INSTITUTE OF TECHNOLOGY, KARAPPAKKAM, CHENGALPATTU 600097",
      code: "1318",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "THANGAVELU ENGINEERING COLLEGE, KARAPPAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600097",
      code: "1319",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DHANALAKSHMI SRINIVASAN COLLEGE OF ENGINEERING AND TECHNOLOGY, EAST COAST ROAD, POONJERI, CHENGALPATTU DISTRICT, CHENNAI 603104",
      code: "1322",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ST. JOSEPH COLLEGE OF ENGINEERING, TRINITY CAMPUS, NEMILI, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1325",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VI INSTITUTE OF TECHNOLOGY, SIRUNKUNDRAM VILLAGE & POST, CHENGALPUT TALUK, CHENGALPATTU DISTRICT 603108",
      code: "1333",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARS COLLEGE OF ENGINEERING, MARAIMALAI NAGAR POST, CHENGALPATTU DISTRICT 603209",
      code: "1334",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MOHAMED SATHAK A J ACADEMY OF ARCHITECTURE, OLD MAHABALIPURAM ROAD (OMR), CHENGALPATTU DISTRICT 603103",
      code: "1400",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ADHIPARASAKTHI ENGINEERING COLLEGE, MELMARUVATHUR, CHENGALPATTU DISTRICT 603319",
      code: "1401",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI TERASA COLLEGE OF ENGINEERING, THIRUNAVALUR, KALLAKURICHI DISTRICT 607204",
      code: "1402",
      branch: "All Branches",
      location: "Kallakkurichi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "G K M COLLEGE OF ENGINEERING AND TECHNOLOGY, ALAPPAKKAM-MAPPEDU ROAD, CHENGALPATTU DISTRICT, CHENNAI 600063",
      code: "1407",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KARPAGAVINAYAGA COLLEGE OF ENGINEERING AND TECHNOLOGY, PALAYANOOR POST, MADURANTHAGAM TALUK, CHENGALPATTU DISTRICT 603308",
      code: "1409",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MADHA ENGINEERING COLLEGE, KUNDRATHUR, CHENNAI 600069",
      code: "1411",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAILAM ENGINEERING COLLEGE, MAILAM, VILLUPURAM DISTRICT 604304",
      code: "1412",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI VENKATESWARAA COLLEGE OF TECHNOLOGY, SIRUKULATHUR, VADAKKAL VILLAGE, PONDUR POST, SRIPERUMBUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1413",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "T S M JAIN COLLEGE OF TECHNOLOGY, MELUR VILLAGE, KALLAKURICHI, KALLAKURICHI DISTRICT 606201",
      code: "1415",
      branch: "All Branches",
      location: "Kallakkurichi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYA SAKTHI ENGINEERING COLLEGE, THIRUNINDRAVUR, CHENNAI 602024",
      code: "1416",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHRI ANDAL ALAGAR COLLEGE OF ENGINEERING, MAMANDUR, CHENGALPATTU DISTRICT 603111",
      code: "1417",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TAGORE ENGINEERING COLLEGE, RATHNAMANGALAM, VANDALUR POST, CHENGALPATTU DISTRICT, CHENNAI 600048",
      code: "1420",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "V R S COLLEGE OF ENGINEERING AND TECHNOLOGY, ARASUR, VILLUPURAM DISTRICT 607107",
      code: "1421",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ASAN MEMORIAL COLLEGE OF ENGINEERING AND TECHNOLOGY, ORAGADAM,CHENGALPATTU 603105",
      code: "1423",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI RAMANUJAR ENGINEERING COLLEGE, VANDALUR, KOLAPPAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600048",
      code: "1426",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "E S COLLEGE OF ENGINEERING AND TECHNOLOGY, CHENNAI TRUNK ROAD, AYYANKOILPATTU, VILLUPURAM DISTRICT 605602",
      code: "1428",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHA BHARATHI ENGINEERING COLLEGE, A VASUDEVANUR, CHINNASALEM, KALLAKURICHI TALUK, KALLAKURICHI DISTRICT 606201",
      code: "1430",
      branch: "All Branches",
      location: "Kallakkurichi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SURYA GROUP OF INSTITUTIONS, GST ROAD, VIKRAVANDI VILLAGE, VILLUPURAM DISTRICT 605652",
      code: "1434",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A R ENGINEERING COLLEGE, VADAKUCHIPALAYAM, KAPPIYAMPULIYUR POST, VILLUPURAM DISTRICT 605601",
      code: "1436",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RRASE COLLEGE OF ENGINEERING, PADAPPAI, CHENNAI 601301",
      code: "1437",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SREE KRISHNA COLLEGE OF ENGINEERING, ANAICUT POST, UNNAI VILLAGE, VELLORE DISTRICT 632101",
      code: "1438",
      branch: "All Branches",
      location: "Vellore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S R I COLLEGE OF ENGINEERING AND TECHNOLOGY, BIRUDUR, VANDAVASI TALUK, THIRUVANNAMALAI DISTRICT 604408",
      code: "1439",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A K T MEMORIAL COLLEGE OF ENGINEERING AND TECHNOLOGY, NEELAMANGALAM VILLAGE, KALLAKURICHI POST & TALUK, KALLAKURICHI DISTRICT 606202",
      code: "1441",
      branch: "All Branches",
      location: "Kallakkurichi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHENDU COLLEGE OF ENGINEERING & TECHNOLOGY, ZAMIN ENDATHUR VILLAGE, MADURANTAKAM TALUK, CHENGALPATTU DISTRICT 603331",
      code: "1444",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI RANGAPOOPATHI COLLEGE OF ENGINEERING, ALAMPOONDI VILLAGE, GINGEE, VILLUPURAM DISTRICT 604151",
      code: "1445",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAWAHAR ENGINEERING COLLEGE, KAVERI RANGAN NAGAR, SALIGRAMAM, CHENNAI 600093",
      code: "1447",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SARASWATHY COLLEGE OF ENGINEERING AND TECHNOLOGY, NH-45, MAIN ROAD, OLAKKUR, TINDIVANAM TALUK, VILLUPURAM DISTRICT 604307",
      code: "1449",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ADHIPARASAKTHI COLLEGE OF ENGINEERING, KALAVAI, RANIPET DISTRICT 632506",
      code: "1501",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARULMIGU MEENAKSHI AMMAN COLLEGE OF ENGINEERING, VADAMAVANDAL,THIRUVANNAMALAI DISTRICT 604410",
      code: "1503",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARUNAI ENGINEERING COLLEGE, MATHUR, THIRUVANNAMALAI DISTRICT 606603",
      code: "1504",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C ABDUL HAKEEM COLLEGE OF ENGINEERING AND TECHNOLOGY, MELVISHARAM, RANIPET DISTRICT 632509",
      code: "1505",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "GANADIPATHY TULSI'S JAIN ENGINEERING COLLEGE, KANIYAMBADI, VELLORE DISTRICT 632102",
      code: "1507",
      branch: "All Branches",
      location: "Vellore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MEENAKSHI COLLEGE OF ENGINEERING, VEMBULIAMMAN KOIL STREET, K K NAGAR (WEST), CHENNAI 600078",
      code: "1509",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PRIYADARSHINI ENGINEERING COLLEGE, VANIYAMBADI POST, TIRUPPATHUR DISTRICT 635751",
      code: "1510",
      branch: "All Branches",
      location: "Thiruppathur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RANIPPETTAI ENGINEERING COLLEGE, THENKADAPPANTHANGAL, RANIPET DISTRICT 632513",
      code: "1511",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S K P ENGINEERING COLLEGE, THIRUVANNAMALAI DISTRICT 606611",
      code: "1512",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI BALAJI CHOCKALINGAM ENGINEERING COLLEGE, ARNI, THIRUVANNAMALAI DISTRICT 632317",
      code: "1513",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI NANDHANAM COLLEGE OF ENGINEERING AND TECHNOLOGY, TIRUPPATTUR DISTRICT 635601",
      code: "1514",
      branch: "All Branches",
      location: "Thiruppathur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "THIRUMALAI ENGINEERING COLLEGE, KILAMBI, KANCHEEPURAM DISTRICT 631551",
      code: "1517",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "THIRUVALLUVAR COLLEGE OF ENGINEERING AND TECHNOLOGY, VANDAVASI, THIRUVANNAMALAI DISTRICT 604505",
      code: "1518",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "BHARATHIDASAN ENGINEERING COLLEGE, NATTRAMPALLI POST, TIRUPPATHUR DISTRICT 635854",
      code: "1519",
      branch: "All Branches",
      location: "Thiruppathur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "GLOBAL INSTITUTE OF ENGINEERING AND TECHNOLOGY, BANGALORE-CHENNAI HIGHWAY, MELVISHARAM, WALAJAH TALUK, RANIPET DISTRICT 632506",
      code: "1523",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAMALAIAR COLLEGE OF ENGINEERING, MODAIYUR VILLAGE, POLUR TALUK, THIRUVANNAMALAI DISTRICT 606902",
      code: "1524",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PODHIGAI COLLEGE OF ENGINEERING AND TECHNOLOGY, VINAYAKAPURAM, ADIYUR POST, TIRUPATTUR DISTRICT 635601",
      code: "1525",
      branch: "All Branches",
      location: "Thiruppathur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "OXFORD COLLEGE OF ENGINEERING, VENMANI VILLAGE, KARAIPOONDI POST, POLUR TALUK, THIRUVANNAMALAI DISTRICT 606803",
      code: "1529",
      branch: "All Branches",
      location: "Thiruvannamalai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PAPNI SCHOOL OF ARCHITECTURE, 302/1, KEERANALLUR VILLAGE, SRIPERUNBUDUR TALUK, KANCHEEPURAM DISTRICT, CHENNAI 602108",
      code: "1530",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PANIMALAR ENGINEERING COLLEGE, CHENNAI CITY CAMPUS 600029",
      code: "1533",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "IDHAYA ENGINEERING COLLEGE FOR WOMEN, CHINNASALEM, KALLAKURICHI DISTRICT 606201",
      code: "1605",
      branch: "All Branches",
      location: "Kallakkurichi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "N S N COLLEGE OF ENGINEERING AND TECHNOLOGY, KARUR-MADURAI NH7, MANALMEDU, KARUR DISTRICT 639003",
      code: "2327",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AISHWARYA COLLEGE OF ENGINEERING AND TECHNOLOGY, ERRATTAIKARADU PARUVACHI POST, ANTHIYUR (VIA), BHAVANI TALUK, ERODE DISTRICT 638312",
      code: "2332",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ASIAN COLLEGE OF ENGINEERING AND TECHNOLOGY, ASIAN COLLEGE ROAD, KONDAYAMPALAYAM, NEAR SARAVANAMPATTI, COIMBATORE DISTRICT 641110",
      code: "2338",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "GANESH COLLEGE OF ENGINEERING, ATTUR MAIN ROAD, METTUPATTI, SALEM DISTRICT 636111",
      code: "2341",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KONGU SCHOOL OF ARCHITECTURE, KONGU ENGINEERING COLLEGE CAMPUS, PERUNDURAI RAILWAY STATION ROAD, THOPPUPALAYAM POST, PERUNDURAI, ERODE DISTRICT 638052",
      code: "2344",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHREE SATHYAM COLLEGE OF ENGINEERING AND TECHNOLOGY, NH-47, MANJAKKALPATTI, KUPPANUR POST, SANKARI TALUK, SALEM DISTRICT 637301",
      code: "2346",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AVS COLLEGE OF TECHNOLOGY, ATTUR MAIN ROAD, NEAR AVS COLLEGE OF ARTS & SCIENCE, CHINNAGOUNDAPURAM, SALEM DISTRICT 636106",
      code: "2347",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SAN ACADEMY OF ARCHITECTURE, ACC PIRIVU, NAVAKARAI POST, MAVUTHAMPATHY VILLAGE, WALAYAR, COIMBATORE DISTRICT 641105",
      code: "2348",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DHAANISH AHMED INSTITUTE OF TECHNOLOGY, PICHANUR POST, (NEAR K G CHAVADI), COIMBATORE DISTRICT 641105",
      code: "2349",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAIRUPAA COLLEGE OF ENGINEERING, THOTTIAPALAYAM, KATHANKANNI POST, KANGAYAM, TIRUPPUR DISTRICT 641 604",
      code: "2350",
      branch: "All Branches",
      location: "Tiruppur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "POLLACHI INSTITUTE OF ENGINEERING AND TECHNOLOGY, MAIN ROAD, POOSARIPATTI, POLLACHI TALUK, COIMBATORE DISTRICT 642205",
      code: "2354",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHERAN COLLEGE OF ENGINEERING, KARUR-COIMBATORE MAIN ROAD, NH-67, K.PARAMATHI POST, ARAVAKURICHI TALUK, KARUR DISTRICT 639111",
      code: "2355",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARULMURUGAN COLLEGE OF ENGINEERING, KARVAZHI ROAD, THENNILAI POST, KARUR DISTRICT 639206",
      code: "2356",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SUGUNA COLLEGE OF ENGINEERING, KALAPPATTI ROAD, CIVIL AERODROME POST, COIMBATORE DISTRICT 641014",
      code: "2360",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SASI CREATIVE SCHOOL OF ARCHIECTURE, POLLACHI MAIN ROAD, MYLERIPALAYAM, COIMBATORE DISTRICT 641032",
      code: "2361",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SCHOOL OF ARCHITECTURE COIMBATORE INSTITUTE OF ENGINEERING AND TECHNOLOGY, VELLIMALAI PATTINAM, NARASIPURAM POST, THONDAMUTHUR VIA, COIMBATORE DISTRICT 641109",
      code: "2364",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NEHRU SCHOOL OF ARCHITECTURE, 451-D, PALAKKAD MAIN ROAD, KUNIAMUTHUR, COIMBATORE DISTRICT 641108",
      code: "2365",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARJUN COLLEGE OF TECHNOLOGY, CHETTIYAKKAPALAYAM, KINATHUKADAVU, COIMBATORE DISTRICT 642120",
      code: "2367",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VISHNU LAKSHMI COLLEGE OF ENGINEERING AND TECHNOLOGY, VELLALORE,COIMBATORE-641111",
      code: "2368",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "HINDUSTHAN SCHOOL OF ARCHITECTURE, OTHAKKALMANDABAM POST, COIMBATORE DISTRICT 641032",
      code: "2373",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RATHINAM SCHOOL OF ARCHITECTURE, RATHINAM TECHZONE CAMPUS POLLACHI ROAD, COIMBATORE DISTRICT 641021",
      code: "2376",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PSG INSTITUTE OF TECHNOLOGY AND APPLIED RESEARCH, AVINASHI ROAD, NEELAMBUR, COIMBATORE 641062",
      code: "2377",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI MATHAMMAL SHEELA ENGINEREING COLLEGE, ERUMAPATTY POST, NAMAKKAL DISTRICT 637013",
      code: "2602",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYAM COLLEGE OF ENGINEERING AND TECHNOLOGY, NALLANUR POST, DHARMAPURI DISTRICT 636813",
      code: "2606",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P G P COLLEGE OF ENGINEERING AND TECHNOLOGY, PARAMATHI POST, NAMAKKAL DISTRICT 637207",
      code: "2612",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S S M COLLEGE OF ENGINEERING, KOMARAPALAYAM, NAMAKKAL DISTRICT 638183",
      code: "2614",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SAPTHAGIRI COLLEGE OF ENGINEERING, PERIYANAHALLI POST, DHARMAPURI DISTRICT 635205",
      code: "2616",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHENDRA COLLEGE OF ENGINEERING, ATTUR ROAD, MINNAMPALLI, VALAPADY, SALEM DISTRICT 636106",
      code: "2623",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHETTINAD COLLEGE OF ENGINEERING AND TECHNOLOGY, NH-67, TRICHY MAIN ROAD, PULIYUR C F, KARUR DISTRICT 639114",
      code: "2630",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VIDYAA VIKAS COLLEGE OF ENGINEERING AND TECHNOLOGY, VARAHOORAMPATTI, TIRUCHENGODE, NAMAKKAL DISTRICT 637 214",
      code: "2633",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C M S COLLEGE OF ENGINEERING, EMAPURAM POST, NAMAKKAL DISTRICT 637003",
      code: "2635",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A V S ENGINEERING COLLEGE, MILITARY ROAD, AMMAPET, SALEM DISTRICT 636003",
      code: "2636",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHENDRA ENGINEERING COLLEGE FOR WOMEN, KUMARAMANGALAM, NAMAKKAL DISTRICT 637205",
      code: "2638",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NARASUS SARATHY INSTITUTE OF TECHNOLOGY, POOSARIPATTY VILLAGE, OMALUR TALUK, SALEM DISTRICT 636305",
      code: "2639",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYALAKSHMI INSTITUTE OF TECHNOLOGY, THOPPUR, DHARMAPURI DISTRICT 635352",
      code: "2640",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VARUVAN VADIVELAN INSTITUTE OF TECHNOLOGY, NALLANAHALLI, DHARMAPURI DISTRICT 636701",
      code: "2641",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "BHARATHIYAR INSTITUTE OF ENGINEERING FOR WOMEN, DEVIAYAKURICHI, ATTUR TALUK, SALEM DISTRICT 636112",
      code: "2643",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TAGORE INSTITUTE OF ENGINEERING AND TECHNOLOGY, DEVIYAKURICHI, ATTUR TALUK, SALEM DISTRICT 636112",
      code: "2646",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHRIST THE KING ENGINEERING COLLEGE, CECILIA GARDENS, CHIKKARAMPALAYAM VILLAGE, COIMBATORE DISTRICT 641104",
      code: "2650",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "V S A GROUP OF INSTITUTIONS, NH-47, UTHAMASOLA PURAM POST, SALEM DISTRICT 636010",
      code: "2658",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SALEM COLLEGE OF ENGINEERING AND TECHNOLOGY, SALEM-ATTUR MAIN ROAD, NH-68, METTUPATTY PERUMAPALAYAM, SALEM DISTRICT 636111",
      code: "2659",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VIVEKANANDHA COLLEGE OF TECHNOLOGY FOR WOMEN, SATHINAICKENPALAYAM, ELAYAMPALAYAM VILLAGE, KUMARAMANGALAM, NAMAKKAL DISTRICT 637205",
      code: "2661",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "THE KAVERY COLLEGE OF ENGINEERING, M KALIPATTI POST, MECHERI, SALEM DISTRICT 636453",
      code: "2666",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "EXCEL COLLEGE OF ARCHITECTURE AND PLANNING, PALLAKAPALAYAM, SANKARI WEST POST, NAMAKKAL DISTRICT 637303",
      code: "2667",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SREE SAKTHI ENGINEERING COLLEGE, BETTATHAPURAM, BILICHI VILLAGE, KARAMADAI, COIMBATORE DISTRICT 641104",
      code: "2673",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHREENIVASA ENGINEERING COLLEGE, B PALLIPATTI, BOMMIDI, PAPPIREDDIPATTI TALUK, DHARMAPURI DISTRICT 635301",
      code: "2683",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TIPS SCHOOL OF ARCHITECTURE, SF 361/1A, KARUVALUR ROAD SS KULAMPO, COIMBATORE 6411407",
      code: "2684",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C S I COLLEGE OF ENGINEERING, KETTI, THE NILGIRIS 643215",
      code: "2705",
      branch: "All Branches",
      location: "The Nilgiris",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M P NACHIMUTHU M JAGANNATHAN ENGINEERING COLLEGE, CHENNIMALAI, ERODE DISTRICT 638112",
      code: "2713",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SASURIE COLLEGE OF ENGINEERING, VIJAYAMANGALAM, TIRUPPUR DISTRICT 638056",
      code: "2717",
      branch: "All Branches",
      location: "Tiruppur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TAMILNADU COLLEGE OF ENGINEERING, KARUMATHAMPATTI POST, COIMBATORE DISTRICT 641659",
      code: "2721",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TAMILNADU SCHOOL OF ARCHITECTURE, KARUMATHAMPATTI POST, COIMBATORE DISTRICT 641659",
      code: "2728",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANGEL COLLEGE OF ENGINEERING AND TECHNOLOGY, P.K.PALAYAM, UGAYANUR VILLAGE, TIRUPUR DISTRICT 641 665",
      code: "2733",
      branch: "All Branches",
      location: "Tiruppur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SURYA ENGINEERING COLLEGE, METTUKADAI, KATHIRAMPATTI POST, ERODE DISTRICT 638107",
      code: "2748",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P P G INSTITUTE OF TECHNOLOGY, VILANKURICHI VILLAGE, COIMBATORE DISTRICT 641035",
      code: "2753",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "J K K MUNIRAJA COLLEGE OF TECHNOLOGY, T N PALAYAM, GOBI TALUK, ERODE DISTRICT 638506",
      code: "2758",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MCGANS OOTY SCHOOL OF ARCHITECTURE, SUMMER HOUSE ROAD, OOTY, THE NILGIRIS 643001",
      code: "2759",
      branch: "All Branches",
      location: "The Nilgiris",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AKSHAYA COLLEGE OF ENGINEERING AND TECHNOLOGY, KINATHUKADAVU, COIMBATORE DISTRICT 642109",
      code: "2763",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRG ENGINEERING COLLEGE, ANIYAPURAM POST, NAMAKKAL DISTRICT 637017",
      code: "2767",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PARK COLLEGE OF TECHNOLOGY, PREMA RAVI NAGAR, KARUMATHAMPATTY, COIMBATORE DISTRICT 641059",
      code: "2768",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "STUDY WORLD COLLEGE OF ENGINEERING, MADUKKARAI, COIMBATORE-641105",
      code: "2770",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C M S COLLEGE OF ENGINEERING AND TECHNOLOGY, APPACHIGOUNDENPATHY, KUMITTIPATTI, COIMBATORE DISTRICT 641105",
      code: "2772",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "R V S TECHNICAL CAMPUS-COIMBATORE, KUMARAN KOTTAM CAMPUS, KANNAMPALAYAM, SULUR, COIMBATORE DISTRICT 641 402",
      code: "2776",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "R V S SCHOOL OF ARCHITECTURE, KUMARAN KOTTAM CAMPUS, TRICHY ROAD, KANNAMPALAYAM, COIMBATORE DISTRICT 641402",
      code: "2778",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RANGANATHAN ARCHITECTURE COLLEGE, VIRALIYUR POST, THONDAMUTHUR VIA, COIMBATORE DISTRICT 641109",
      code: "2779",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S V S SCHOOL OF ARCHITECTURE, ASARAMPALAYAM POST, POLLACHI TALUK, COIMBATORE DISTRICT 642109",
      code: "2780",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHALAKSHMI ENGINEERING COLLEGE, TRICHY-SALEM HIGHWAYS, (NEAR NO.1 TOLLGATE), MELPATHU, SIRUGANBUR POST, TIRUCHIRAPPALLI DISTRICT 621213",
      code: "3403",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KRISHNASWAMY COLLGE OF ENGINEERING AND TECHNOLOGY, S KUMARAPURAM, CUDDALORE DISTRICT 607109",
      code: "3410",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C K COLLEGE OF ENGINEERING AND TECHNOLOGY, CHELLANGKUPPAM, CUDDALORE DISTRICT 607003",
      code: "3425",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PRIME COLLEGE OF ARCHITECTURE AND PLANNING, MAIN ROAD, KILVELUR, NAGAPATTINAM DISTRICT 611104",
      code: "3446",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SMR EAST COAST COLLEGE OF ENGINEERING & TECHNOLOGY, EAST COAST ROAD, SOMANATHAPATTINAM, THANJAVUR DISTRICT 614612",
      code: "3451",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RVS KVK SCHOOL OF ARCHITECTURE, DINDIGUL HIGHWAY, INAMKULATHUR, TIRUCHIRAPPALLI DISTRICT 621303",
      code: "3453",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI RAMAKRISHNA COLLEGE OF ENGINEERING, SRI SARADHA NAGAR, NH-45, PERAMBALUR DISTRICT 621113",
      code: "3454",
      branch: "All Branches",
      location: "Perambalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "K S K COLLEGE OF ENGINEERING AND TECHNOLOGY, THANJAVUR MAIN ROAD, DARASURAM, KUMBAKONAM, THANJAVUR DISTRICT 612702",
      code: "3456",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SUREYA COLLEGE OF ENGINEERING, KONALAI, TIRUCHIRAPPALLI DISTRICT 621132",
      code: "3460",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARIFA INSTITUTE OF TECHONOLOGY, ESANOOR, KEELAIYUR POST, THIRUKKUVALAI TALUK, NAGAPATTINAM DISTRICT 611103",
      code: "3461",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARIYALUR ENGINEERING COLLEGE, NH-227, TRICHY-CHITHAMBARAM NH, KARUPPUR-SENAPATHY POST, ARIYALUR DISTRICT 621707",
      code: "3462",
      branch: "All Branches",
      location: "Ariyalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NELLIANDAVAR INSTITUTE OF TECHNOLOGY, NERUNJIKORAI VILLAGE, PUDHUPALAYAM, ARIYALUR DISTRICT 621704",
      code: "3466",
      branch: "All Branches",
      location: "Ariyalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PRIME NEST COLLEGE OF ARCHITECTURE AND PLANNING, V.J.P. CAMPUS, TRICHY-CHENNAI HIGHWAY, NAVALADIYAN NAGAR, SIRUGANUR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3467",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SIR ISSAC NEWTON COLLEGE OF ENGINEERING AND TECHNOLOGY, ANTHANAPEETAI POST, PAPAKOIL, NAGAPPATTINAM DISTRICT 611102",
      code: "3760",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "STAR LION COLLEGE OF ENGINEERING & TECHNOLOGY, MANANKORAI MAIN ROAD, MANANKORAI VILLAGE, THANJAVUR DISTRICT 614206",
      code: "3766",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "OASYS INSTITUTE OF TECHNOLOGY , PULIVALAM VILLAGE, MUSIRI TALUK, TIRUCHIRAPPALLI DISTRICT 626001",
      code: "3782",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M.A.M. SCHOOL OF ARCHITECTURE, SIRUGANUR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3783",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C.A.R.E SCHOOL OF ARCHITECTURE, ENGINEERING, THAYANOOR VILLAGE, KUTTAPPATTI, SRIRANGAM TALUK, TIRUCHIRAPPALLI DISTRICT 620009",
      code: "3784",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M.A.M. SCHOOL OF ENGINEERING, SIRUGANUR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3786",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRM TRP ENGINEERING COLLEGE, IRUNGALUR, MANACHANALLUR TALUK, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3795",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A V C COLLEGE OF ENGINEERING, MANNAMPANDAL POST, MAYILADUTHURAI, NAGAPPATTINAM DISTRICT 609305",
      code: "3801",
      branch: "All Branches",
      location: "Mayiladuthurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHRI ANGALAMMAN COLLEGE OF ENGINEERING AND TECHNOLOGY SIRUGANOOR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3802",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANJALAI AMMAL-MAHALINGAM ENGINEERING COLLEGE, KOVILVENNI, THIRUVARUR DISTRICT 614403",
      code: "3803",
      branch: "All Branches",
      location: "Thiruvarur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARASU ENGINEERING COLLEGE, CHENNAI MAIN ROAD, KUMBAKONAM, THANJAVUR DISTRICT 612501",
      code: "3804",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYARAM COLLEGE OF ENGINEERING AND TECHNOLOGY , PAGALAVADI POST, TIRUCHIRAPPALLI DISTRICT 621014",
      code: "3808",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KURINJI COLLEGE OF ENGINEERING AND TECHNOLOGY, MANAPPARAI, TIRUCHIRAPPALLI DISTRICT 621307",
      code: "3809",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M.A.M. COLLEGE OF ENGINEERING, SIRUGANUR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3810",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MOOKAMBIGAI COLLEGE OF ENGINEERING, KEERANUR, PUDUKKOTTAI DISTRICT 622502",
      code: "3812",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "OXFORD ENGINEERING COLLEGE, PIRATTIYUR(W), TIRUCHIRAPPALLI DISTRICT 620009",
      code: "3813",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P R ENGINEERING COLLEGE, VALLAM, THANJAVUR DISTRICT 613403",
      code: "3814",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PAVENDHAR BHARATHIDASAN COLLEGE OF ENGINEERING AND TECHNOLOGY, PUDUKKOTTAI MAIN ROAD, TIRUCHIRAPPALLI DISTRICT 620024",
      code: "3815",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SARANATHAN COLLEGE OF ENGINEERING, PANJAPPUR, TIRUCHIRAPPALLI DISTRICT 620012",
      code: "3819",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "TRICHY ENGINEERING COLLEGE, KONALAI, TIRUCHIRAPPALLI DISTRICT 621132",
      code: "3820",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A R J COLLEGE OF ENGINEERING AND TECHNOLOGY, MANNARGUDI TALUK, THIRUVARUR DISTRICT 614001",
      code: "3821",
      branch: "All Branches",
      location: "Thiruvarur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DR. NAVALAR NEDUNCHEZHIAN COLLEGE OF ENGINEERING, THOLUDUR, CUDDALORE DISTRICT 606303",
      code: "3822",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ST. JOSEPHS COLLEGE OF ENGINEERING AND TECHNOLOGY, ELUPATTI VILLAGE, RAWASPATTI POST, THANJAVUR DISTRICT 613403",
      code: "3825",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M.A.M. COLLEGE OF ENGINEERING AND TECHNOLOGY, TRICHY-CHENNAI TRUNK ROAD, SIRUGANUR, TIRUCHIRAPPALLI DISTRICT 621105",
      code: "3829",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C.A.R.E GROUP OF INSTITUTIONS, THAYANOOR VILLAGE, THAYANOOR VILLAGE, KUTTAPPATTI, SRIRANGAM TALUK, TIRUCHIRAPPALLI DISTRICT 620009",
      code: "3841",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M R K INSTITUTE OF TECHNOLOGY, NATTARMANGALAM VILLAGE, KATTUMANNARKOIL, CUDDALORE DISTRICT 608306",
      code: "3843",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHIVANI ENGINEERING COLLEGE, AMMAPETTAI, SRIRANGAM, TIRUCHIRAPPALLI DISTRICT 620009",
      code: "3844",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "IMAYAM COLLEGE OF ENGINEERING, KANNANUR, THURAIYUR, TIRUCHIRAPPALLI DISTRICT 621206",
      code: "3845",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MOTHER TERASA COLLEGE OF ENGINEERING AND TECHNOLOGY, METTUSALAI POST AND TALUK, PUDUKKOTTAI DISTRICT 622102",
      code: "3846",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VANDAYAR ENGINEERING COLLEGE, PULAVARNATHAM POST, MARIAMMAN KOIL (VIA), THANJAVUR DISTRICT 613001",
      code: "3848",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI COLLEGE OF ENGINEERING AND TECHNOLOGY, KOVILACHERI, KUMBAKONAM, THANJAVUR DISTRICT 612503",
      code: "3849",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VETRI VINAYAHA COLLEGE OF ENGINEERING AND TECHNOLOGY, NAMAKKAL-TRICHY MAIN ROAD, THOLURPATTI VILLAGE, THOTTIAM, TIRUCHIRAPPALLI DISTRICT 621215",
      code: "3850",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI BHARATHI ENGINEERING COLLEGE FOR WOMEN, KAIKKURUCHI VILLAGE, ALANGUDI TALUK, PUDUKKOTTAI DISTRICT 622303",
      code: "3852",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHATH AMMA INSTITUTE OF ENGINEERING AND TECHNOLOGY (MIET), ARIYUR, ANNAVASAL ROAD, ILLUPUR TALUK, PUDUKKOTTAI DISTRICT 622101",
      code: "3854",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AS-SALAM COLLEGE OF ENGINEERING AND TECHNOLOGY, THIRUMANGALAKUDI, ADUTHURAI, THIRUVIDAIMARUTHUR, THANJAVUR DISTRICT 612102",
      code: "3855",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MEENAKSHI RAMASWAMY ENGINEERING COLLEGE, TRICHY MAIN ROAD, THATHANUR, UDAYARPALAYAM, ARIYALUR DISTRICT 621804",
      code: "3857",
      branch: "All Branches",
      location: "Ariyalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SEMBODAI RUKMANI VARATHARAJAN ENGINEERING COLLEGE, SEMBODAI VILLAGE, VEDARANIAM, NAGAPPATTINAM DISTRICT 614820",
      code: "3859",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ST. ANNES COLLEGE OF ENGINEERING AND TECHNOLOGY, ANGUCHETTYPALAYAM, SIRUVATHUR POST, PANRUTI, CUDDALORE DISTRICT 607110",
      code: "3860",
      branch: "All Branches",
      location: "Cuddalore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MOUNT ZION COLLEGE OF ENGINEERING AND TECHNOLOGY, PILIVALAM POST, PUDUKKOTTAI DISTRICT 622507",
      code: "3908",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SHANMUGANATHAN ENGINEERING COLLEGE, PILLIVALAM POST, PUDUKKOTTAI DISTRICT 622507",
      code: "3918",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SUDHARSAN ENGINEERING COLLEGE, SATHIYAMANGALAM POST, PUDUKKOTTAI DISTRICT 622501",
      code: "3920",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M N S K COLLEGE OF ENGINEERING, VALLATHIRAKKOTTAI POST, PUDUKKOTTAI DISTRICT 622305",
      code: "3923",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHENDHURAN COLLEGE OF ENGINEERING AND TECHNOLOGY, THIRUMAYAM TK, PUDUKKOTTAI-622507",
      code: "3926",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "THAMIRABHARANI ENGINEERING COLLEGE, CHATHIRAMPUDUKULAM VILLAGE, THATCHANALLUR, TIRUNELVELI DISTRICT 625358",
      code: "4669",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SIGMA COLLEGE OF ARCHITECTURE, MOODODU, ANDUCODE POST, MARTHANDAM, KANYAKUMARI DISTRICT 629168",
      code: "4671",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "UNIVERSAL COLLEGE OF ENGINEERING AND TECHNOLOGY, ANBAGAM CAMPUS, RADHAPURAM ROAD, VALLIOOR, TIRUNELVELI DISTRICT 627117",
      code: "4675",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RENGANAYAGI VARATHARAJ COLLEGE OF ENGINEERING, SALVARPATTI, SIVAKASI, VIRUDHUNAGAR DISTRICT 626128",
      code: "4676",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "LOURDES MOUNT COLLEGE OF ENGINEERING AND TECHNOLOGY, MARTHANDAM-KARUNGAL ROAD, CHUNDAVILAI, MULLANGANAVILAI, NATTALAM POST, KANYAKUMARI DISTRICT 629195",
      code: "4677",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RAMCO INSTITUTE OF TECHNOLOGY, NORTH VENGANALLUR VILLAGE, KRISHNAPURAM PANCHAYAT, RAJAPALAYAM, VIRUDHUNAGAR DISTRICT 626117",
      code: "4678",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "V.P.M.M. COLLEGE OF ARCHITECTURE FOR WOMEN,V.P.M. NAGAR, KRISHNANKOIL, SRIVILLIPUTTUR, VIRUDHUNAGAR DISTRICT 626190",
      code: "4679",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "GOOD SHEPHERD COLLEGE OF ENGINEERING AND TECHNOLOGY, MARUTHAMPARAI, KANYAKUMARI DISTRICT 629101",
      code: "4686",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "V V COLLEGE OF ENGINEERING, ARASOOR VILLAGE, IDAICHIVILAI POST, SANTHAKULAM TALUK, THOOTHUKUDI DISTRICT 628656",
      code: "4864",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SUN COLLEGE OF ENGINEERING AND TECHNOLOGY, AMMANDIVILAI POST, KANYAKUMARI-629204",
      code: "4925",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MARIA COLLEGE OF ENGINEERING AND TECHNOLOGY, ATTOOR PULIYAMOODU JUNCTION, THIRUVATTAR POST, KANYAKUMARI DISTRICT 629177",
      code: "4927",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAR EPHRAEM COLLEGE OF ENGINEERING & TECHNOLOGY, MALANKARA HILLS, ELAVUVILLAI, MARTHANDAM, KANYAKUMARI DISTRICT 629171",
      code: "4928",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "M E T ENGINEERING COLLEGE, MOGALS GARDEN, THOVALAI VILLAGE, ARALVAIMOZHI TOWN PANCHAYAT, THOVALAI, KANYAKUMARI DISTRICT 629304",
      code: "4929",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHANDY COLLEGE OF ENGINEERING, CHANDY NAGAR, MULLAKKADU, THOOTHUKUDI DISTRICT 628005",
      code: "4931",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "IMMANUEL ARASAR J J COLLEGE OF ENGINEERING, ANAPPARA, EDAVILAGAM, NATTALAM, KANYAKUMARI DISTRICT 629195",
      code: "4932",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ST. MOTHER THERESA ENGINEERING COLLEGE, VAGAIKULAM, THOOTHUKUDI DISTRICT 628102",
      code: "4933",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "HOLY CROSS ENGINEERING COLLEGE, VAGAIKULAM, SRI MULAKARAI, SRIVAIKUNTAM, THOOTHUKUDI DISTRICT 628851",
      code: "4934",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "A R COLLEGE OF ENGINEERING AND TECHNOLOGY, KADAYAM-ALANGULAM ROAD, THERIKKUMADATHOOR POST, TENKASI DISTRICT 627423",
      code: "4937",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SIVAJI COLLEGE OF ENGINEERING AND TECHNOLOGY, MANIVILLA PALULAI PANCHAYAT, VILAVANCODE, KANYAKUMARI DISTRICT 629170",
      code: "4938",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "UNNAMALAI INSTITUTE OF TECHNOLOGY, AYYANERI, KOVILPATTI, THOOTHUKUDI DISTRICT 628502",
      code: "4941",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SATYAM COLLEGE OF ENGINEERING & TECHNOLOGY, KANNAPPANNALLUR, ARALVAIMOZHI, KANYAKUMARI DISTRICT 629301",
      code: "4943",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ARUNACHALA COLLEGE OF ENGINEERING FOR WOMEN, THANKA GARDENS, MANAVILAI, VELLICHANTHAI, NAGERCOIL, KANYAKUMARI DISTRICT 629203",
      code: "4944",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VINS CHRISTIAN WOMENS COLLEGE OF ENGINEERING, CHUNKANKADAI POST, NAGERCOIL, KANYAKUMARI DISTRICT 629807",
      code: "4945",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "D M I ENGINEERING COLLEGE, ARALVAIMOZHI VILLAGE, THOVALAI, KANYAKUMARI DISTRICT 629301",
      code: "4946",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RAJAS INTERNATIONAL INSTITUTE OF TECHNOLOGY FOR WOMEN, OZHUGINASERY, NAGERCOIL, KANYAKUMARI DISTRICT 629001",
      code: "4948",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "C S I INSTITUTE OF TECHNOLOGY, THOVALAI, KANYAKUMARI DISTRICT 629302",
      code: "4952",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CAPE INSTITUTE OF TECHNOLOGY, LEVINGIPURAM, TIRUNELVELI DISTRICT 627114",
      code: "4953",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DR. SIVANTHI ADITANAR COLLEGE OF ENGINEERING, TIRUCHENDUR, THOOTHUKUDI DISTRICT 628215",
      code: "4954",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYAMATHA ENGINEERING COLLEGE, ARALVAIMOZHI, KANYAKUMARI-629301",
      code: "4956",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAYARAJ ANNAPACKIAM CSI COLLEGE OF ENGINEERING, NAZARETH, THOOTHUKUDI DISTRICT 628617",
      code: "4957",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NATIONAL COLLEGE OF ENGINEERING, MARUTHAKULAM POST, TIRUNELVELI DISTRICT 627151",
      code: "4961",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PET ENGINEERING COLLEGE, VALLIOOR POST, TIRUNELVELI DISTRICT 627117",
      code: "4966",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "S VEERASAMY CHETTIAR COLLEGE OF ENGINEERING AND TECHNOLOGY, PULIANGUDI POST, TENKASI DISTRICT 627855",
      code: "4967",
      branch: "All Branches",
      location: "Tenkasi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SARDAR RAJA COLLEGE OF ENGINEERING, ALANGULAM, TENKASI DISTRICT 627808",
      code: "4968",
      branch: "All Branches",
      location: "Tenkasi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SCAD COLLEGE OF ENGINEERING AND TECHNOLOGY, CHERANMAHADEVI, TIRUNELVELI DISTRICT 627414",
      code: "4969",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AMRITA COLLEGE OF ENGINEERING AND TECHNOLOGY, ERACHAKULAM POST, KANYAKUMARI DISTRICT 629902",
      code: "4972",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "DR. G U POPE COLLEGE OF ENGINEERING, SAWYERPURAM, THOOTHUKUDI DISTRICT 628251",
      code: "4975",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "INFANT JESUS COLLEGE OF ENGINEERING, THOOTHUKUDI HIGHWAY (NH7/A), THOOTHUKUDI DISTRICT 628851",
      code: "4976",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NARAYANAGURU COLLEGE OF ENGINEERING, MANJALUMOODU, KANYAKUMARI DISTRICT 629151",
      code: "4977",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "UDAYA SCHOOL OF ENGINEERING, AMMANDIVILAI POST, KANYAKUMARI DISTRICT 629204",
      code: "4978",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "V P MUTHAIAH PILLAI MEENAKSHI AMMAL ENGINEERING COLLEGE FOR WOMEN, SRIVILLIPUTHUR TALUK, VIRUDHUNAGAR DISTRICT 626190",
      code: "4979",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "EINSTEIN COLLEGE OF ENGINEERING, SEETHAPARPANALLUR, TIRUNELVELI DISTRICT 627012",
      code: "4980",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PONJESLY COLLEGE OF ENGINEERING, VETTORNIMADAM POST, NAGERCOIL, KANYAKUMARI DISTRICT 629003",
      code: "4981",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VINS CHRISTIAN COLLEGE OF ENGINEERING, CHUNKANKADAI POST, NAGERCOIL, KANYAKUMARI DISTRICT 629807",
      code: "4982",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "LORD JEGANNATH COLLEGE OF ENGINEERING AND TECHNOLOGY, KUMARAPURAM, THOPPUR POST, KANYAKUMARI DISTRICT 629402",
      code: "4983",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MARTHANDAM COLLEGE OF ENGINEERING & TECHNOLOGY, KUTTAKUZHI, VEEYANOOR POST, KANYAKUMARI DISTRICT 629177",
      code: "4984",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P S N ENGINEERING COLLEGE, MELATHEDIYOOR, TIRUNELVELI DISTRICT 627152",
      code: "4989",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KALASALINGAM INSTITUTE OF TECHNOLOGY, KRISHNANKOIL,VIRUDHUNAGAR-626190",
      code: "4991",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "BETHLAHEM INSTITUTE OF ENGINEERING, KARUNGAL, KANYAKUMARI DISTRICT 629157",
      code: "4992",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "J P COLLEGE OF ENGINEERING, COLLEGE ROAD, AYAKUDY, TENKASI TALUK, TENKASI DISTRICT 627852",
      code: "4994",
      branch: "All Branches",
      location: "Tenkasi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P S R RENGASAMY COLLEGE OF ENGINEERING FOR WOMEN, APPAYANAICKENPATTI, SEVALPATTI, VIRUDHUNAGAR DISTRICT 626140",
      code: "4995",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI VIDHYA COLLEGE OF ENGINEERING AND TECHNOLOGY, SIVAKASI MAIN ROAD, P KUMARALINAPURAM, VIRUDHUNAGAR DISTRICT 626005",
      code: "4996",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MAHAKAVI BHARATHIYAR COLLEGE OF ENGINEERING AND TECHNOLOGY, VASUDEVANALLUR, TENKASI DISTRICT 627758",
      code: "4998",
      branch: "All Branches",
      location: "Tenkasi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "ANNAI VAILANKANNI COLLEGE OF ENGINEERING, POTHAIYADI SALAI, POTTALKULAM, AZHAGAPPAPURAM, KANYAKUMARI DISTRICT 629401",
      code: "4999",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CENTRAL ELECTROCHEMICAL RESEARCH INSTITUTE, CECRI, KARAIKUDI, SIVAGANGAI DISTRICT 630006 - SIVAGANGAI",
      code: "5012",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SREE RAAJA RAAJAN COLLEGE OF ENGINEERING & TECHNOLOGY, AMARAVATHI VILLAGE, AMARAVATHI PUDUR POST, KARAIKUDI, SIVAGANGAI DISTRICT 630301",
      code: "5502",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SSM INSTITUTE OF ENGINEERING AND TECHNOLOGY, KUTTATHUPATTI VILLAGE, SINDALAIGUNDU POST, DINDIGUL DISTRICT 624002",
      code: "5530",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VAIGAI COLLEGE OF ENGINEERING, THERKUTHERU, MELUR TALUK, MADURAI DISTRICT 625122",
      code: "5532",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "KARAIKUDI INSTITUTE OF TECHNOLOGY, KIT & KIM TECHNICAL CAMPUS, KEERANIPATTI, THALAKKUVUR, KARAIKUDI, SIVAGANGAI DISTRICT 630307",
      code: "5533",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MANGAYARKARASI COLLEGE OF ENGINEERING, FIRST STREET, MANGAYARKARASI NAGAR, PARAVAI, MADURAI DISTRICT 625402",
      code: "5536",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "JAINEE COLLEGE OF ENGINEERING AND TECHNOLOGY, DINDIGUL-THENI MAIN ROAD (NEAR VAKKAMPATTI), DINDIGUL DISTRICT 624303",
      code: "5537",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "J.K. COLLEGE OF ARCHITECTURE, NH-7, MADURAI ROAD, BEGAMPUR POST, DINDIGUL 624002",
      code: "5538",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "AGNI SCHOOL OF ARCHITECTURE AND DESIGN EXCELLENCE (ASADE), NH45, TRICHY ROAD, MOREPATTI, VADAMADURAI, DINDIGUL DISTRICT 624001",
      code: "5544",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "CHRISTIAN COLLEGE OF ENGINEERING AND TECHNOLOGY, ODDANCHATRAM, DINDIGUL DISTRICT 624619",
      code: "5703",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SRI SUBRAMANYA COLLEGE OF ENGINEERING AND TECHNOLOGY, SUKKAMANAICKANPATTI, PALANI, DINDIGUL DISTRICT 624615",
      code: "5720",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MADURAI INSTITUTE OF ENGINEERING & TECHNOLOGY, POTTAPALAYAM VILLAGE, MANAMADURAI TALUK, SIVAGANGAI DISTRICT 630611",
      code: "5842",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "VEERAMMAL ENGINEERING COLLEGE, K SINGARAKOTTAI, DINDIGUL DISTRICT 624708",
      code: "5851",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "R V S SCHOOL OF ARCHITECTURE, N PARAIPATTI POST, VEDASANDUR TALUK, DINDIGUL DISTRICT 624005",
      code: "5863",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "NADAR SARASWATHI COLLEGE OF ENGINEERING AND TECHNOLOGY, VADUPUDUPATTI, ANNANJI POST, THENI DISTRICT 625531",
      code: "5865",
      branch: "All Branches",
      location: "Theni",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "BHARATH NIKETAN ENGINEERING COLLEGE, THIMMARASANAICKANOOR, AUNDIPATTI, THENI DISTRICT 625536",
      code: "5902",
      branch: "All Branches",
      location: "Theni",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "K L N COLLEGE OF INFORMATION TECHNOLOGY, POTTAPALAYAM, SIVAGANGAI DISTRICT 630611",
      code: "5903",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "MOHAMED SATHAK ENGINEERING COLLEGE, KILAKARAI, RAMANATHAPURAM DISTRICT 623806",
      code: "5907",
      branch: "All Branches",
      location: "Ramanathapuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "P T R COLLEGE OF ENGINEERING AND TECHNOLOGY, AUSTINPATTY POST, MADURAI DISTRICT 625008",
      code: "5911",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "PANDIAN SARASWATHI YADAV ENGINEERING COLLEGE, THIRUMANSOLAI POST, SIVAGANGAI DISTRICT 630 561",
      code: "5912",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "RATNAVEL SUBRAMANIAM COLLEGE OF ENGINEERING AND TECHNOLOGY, N PARAIPATTI POST, DINDIGUL DISTRICT 624005",
      code: "5913",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    {
      name: "SOLAIMALAI COLLEGE OF ENGINEERIG, VEERAPANJAN, MADURAI DISTRICT 625020",
      code: "5914",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Non-Autonomous"
    },
    // Adding provided Autonomous colleges
    {
      name: "PRATHYUSHA ENGINEERING COLLEGE, ARANVOYALKUPPAM, THIRUVALLUR DISTRICT 602025",
      code: "1110",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "LOYOLA INSTITUTE OF TECHNOLOGY AND SCIENCE, LOYOLA NAGAR, P B NO.2, THOVALAI, KANYAKUMARI DISTRICT 629302",
      code: "4993",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "R M D ENGINEERING COLLEGE, KAVARAIPETTAI, GUMMIDIPOONDI, THIRUVALLUR DISTRICT 601206",
      code: "1112",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "SRI SHANMUGHA COLLEGE OF ENGINEERING AND TECHNOLOGY, MORUR BIT II VILLAGE, SALEM DISTRICT 637302",
      code: "2302",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
      {
      name: "AGNI COLLEGE OF TECHNOLOGY, OLD MAHABALIPURAM ROAD (OMR), THALAMBUR VILLAGE, CHENGALPATTU DISTRICT 603103",
      code: "1316",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "R M K ENGINEERING COLLEGE, KAVARAIPETTAI, GUMMIDIPOONDI, THIRUVALLUR DISTRICT 601206",
      code: "1113",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "S A ENGINEERING COLLEGE, THIRUVERKADU, CHENNAI 600077",
      code: "1114",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VEL TECH MULTI TECH DR. RANGARAJAN DR. SAKUNTHALA ENGINEERING COLLEGE (AUTONOMOUS), AVADI-ALAMATHI ROAD, CHENNAI 600 062",
      code: "1118",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VELAMMAL ENGINEERING COLLEGE (AUTONOMOUS), AMBATTUR-REDHILLS ROAD, CHENNAI 600066",
      code: "1120",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VEL TECH HIGH TECH DR. RANGARAJAN DR. SAKUNTHALA ENGINEERING COLLEGE, AVADI-ALAMATHI ROAD, CHENNAI 600 062",
      code: "1122",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "J N N INSTITUTE OF ENGINEERING, USHAA GARDEN, KANNIGAIPAIR VILLAGE, UTHUKOTTAI TALUK, THIRUVALLUR DISTRICT 601102",
      code: "1126",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "BALAJI INSTITUTE OF ENGINEERING AND TECHNOLOGY, THANDALAM VILLAGE, THIRUPORUR, KANCHEEPURAM DISTRICT 603110",
      code: "1435",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI SAI RANGANATHAN ENGINEERING COLLEGE, ZAHIRNAICKENPALAYAM VILLAGE, VIRALIYUR POST, THONDAMUTHUR VIA, COIMBATORE DISTRICT 641109",
      code: "2737",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "R M K COLLEGE OF ENGINEERING AND TECHNOLOGY, PUDUVOYAL, GUMMIDIPOONDI TALUK, THIRUVALLUR DISTRICT 601206",
      code: "1128",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ST. JOSEPHS INSTITUTE OF TECHNOLOGY, JEPPIAAR NAGAR, OLD MAHABALIPURAM ROAD OMR, CHENGALPATTU DISTRICT, CHENNAI 600119",
      code: "1149",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PANIMALAR ENGINEERING COLLEGE, NAZARETHPET, POONAMALLEE, CHENNAI 602103",
      code: "1210",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "RAJALAKSHMI ENGINEERING COLLEGE, THANDALAM, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1211",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SREE SOWDAMBIGA COLLEGE OF ENGINEERING, ARUPPUKKOTTAI TALUK, VIRUDHUNAGAR DISTRICT 626134",
      code: "4970",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KATHIR COLLEGE OF ENGINEERING, NEELAMBUR, AVINASHI ROAD, COIMBATORE DISTRICT 641062",
      code: "2745",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SAVEETHA ENGINEERING COLLEGE (AUTONOMOUS), THANDALAM, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1216",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI KRISHNA INSTITUTE OF TECHNOLOGY, PANAPAKKAM, PADAPPAI, CHENNAI 601301",
      code: "1335",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI VENKATESWARA COLLEGE OF ENGINEERING (AUTONOMOUS), POST BAG NO.1, CHENNAI-BENGALURU HIGH ROAD, PENNALUR, IRUNGATTUKOTTAI S.O., SRIPERUMBUDUR TALUK, KANCHEEPURAM DISTRICT 602117",
      code: "1219",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "EASWARI ENGINEERING COLLEGE, RAMAPURAM, CHENNAI 600089",
      code: "1304",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "JERUSALEM COLLEGE OF ENGINEERING (AUTONOMOUS), NARAYANAPURAM, PALLIKARANAI, CHENGALPATTU DISTRICT, CHENNAI 600100",
      code: "1307",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K C G COLLEGE OF TECHNOLOGY, KARAPPAKKAM, CHENNAI 600096",
      code: "1311",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI SIVASUBRAMANIYA NADAR COLLEGE OF ENGINEERING (AUTONOMOUS), KALAVAKKAM, OLD MAHABALIPURAM ROAD (OMR), CHENGALPATTU DISTRICT 603110",
      code: "1315",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ST. JOSEPHS COLLEGE OF ENGINEERING, OLD MAHABALIPURAM ROAD OMR, CHENGALPATTU DISTRICT, CHENNAI 600119",
      code: "1317",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI SAI RAM INSTITUTE OF TECHNOLOGY, WEST TAMBARAM, CHENGALPATTU DISTRICT, CHENNAI 600044",
      code: "1324",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "PRINCE DR. K VASUDEVAN COLLEGE OF ENGINEERING AND TECHNOLOGY, MEDAVAKKAM-MAMBAKKAM ROAD, PONMAR, CHENNAI 600048",
      code: "1442",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "CHENNAI INSTITUTE OF TECHNOLOGY, PUDUPER VILLAGE, NANDAMBAKKAM POST, KUNDRATHUR, CHENNAI 600069",
      code: "1399",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "D M I COLLEGE OF ENGINEERING, PALANCHOOR, NAZRETHPET, CHENNAI 602103",
      code: "1202",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "BUILDERS ENGINEERING COLLEGE,ERODE ROAD,NATHAKADIYUR, KANGEYAM TALUK, TIRUPPUR DISTRICT 638108",
      code: "2656",
      branch: "All Branches",
      location: "Tiruppur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "I F E T COLLEGE OF ENGINEERING AUTONOMOUS, GANGARAMPALAYAM, VILLUPURAM DISTRICT 605108",
      code: "1408",
      branch: "All Branches",
      location: "Villupuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PRINCE SHRI VENKATESHWARA PADMAVATHY ENGINERING COLLEGE, PONMAR, CHENNAI 600048",
      code: "1414",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI SAIRAM ENGINERING COLLEGE, WEST TAMBARAM, CHENGALPATTU DISTRICT, CHENNAI 600044",
      code: "1419",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "KINGS ENGINEERING COLLEGE, SRIPERUMPUDUR TALUK, KANCHEEPURAM DISTRICT 602105",
      code: "1207",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRM VALLIAMMAI ENGINEERING COLLEGE (AUTONOMOUS), KATTANKULATHUR, CHENGALPATTU DISTRICT, CHENNAI 603203",
      code: "1422",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "NEW PRINCE SHRI BHAVANI COLLEGE OF ENGINEERING AND TECHNOLOGY, VENGAIVASAL MAIN ROAD, GOWRIWAKKAM, CHENGALPATTU DISTRICT, CHENNAI 600073",
      code: "1431",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
        {
      name: "V S B COLLEGE OF ENGINEERING TECHNICAL CAMPUS, EALUR PIRIVU, SOLAVAMPALAYAM POST, COIMBATORE DISTRICT 642109",
      code: "2357",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PAAVAI COLLEGE OF ENGINEERING, NH-7, PACHAL POST, NAMAKKAL DISTRICT 637018",
      code: "2628",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MAHENDRA INSTITUTE OF ENGINEERING AND TECHNOLOGY, MAHENDRAPURI, MALLASAMUDRAM, NAMAKKAL DISTRICT 637503",
      code: "2665",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "RAJALAKSHMI INSTITUTE OF TECHNOLOGY, IRULAPALAYAM, KUTHAMPAKKAM POST, KANCHEEPURAM DISTRICT 602107",
      code: "1432",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "J K K NATARAJA COLLEGE OF ENGINEERING AND TECHNOLOGY, KOMARAPALAYAM AMANI, THATTANKUTTAI PANCHAYAT, NAMAKKAL DISTRICT 638183",
      code: "2647",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K S R INSTITUTE FOR ENGINEERING AND TECHNOLOGY, THOKKAVADI, NAMAKKAL DISTRICT 637215",
      code: "2328",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KGISL INSTITUTE OF TECHNOLOGY, KGISL CAMPUS, THUDIYALUR ROAD, SARAVANAMPATTI, COIMBATORE DISTRICT 641035",
      code: "2751",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "JAI SHRIRAM ENGINEERING COLLEGE, DHARAPURAM ROAD, AVINASHI PALAYAM, TIRUPPUR DISTRICT 638660",
      code: "2651",
      branch: "All Branches",
      location: "Tiruppur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "EXCEL COLLEGE OF ENGINEERING AND TECHNOLOGY, PALLAKAPALAYAM, SANKARI WEST POST, NAMAKKAL DISTRICT 637303",
      code: "2664",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "RATHINAM TECHNICAL CAMPUS, POLLACHI ROAD, EACHANARI, COIMBATORE DISTRICT 641021",
      code: "2329",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DHANALAKSHMI SRINIVASAN COLLEGE OF ENGINEERING, NH47, PALAKKAD MAIN ROAD, NAVAKKARAI POST, NEAR NANDHI TEMPLE, COIMBATORE DISTRICT 641105",
      code: "2743",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ADHIYAMAAN COLLEGE OF ENGINEERING (AUTONOMOUS), HOSUR, KRISHNAGIRI DISTRICT 635109",
      code: "2601",
      branch: "All Branches",
      location: "Krishnagiri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K S RANGASAMY COLLEGE OF TECHNOLOGY (AUTONOMOUS), TIRUCHENGODE, NAMAKKAL DISTRICT 637215",
      code: "2607",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MUTHAYAMMAL COLLEGE OF ENGINEERING, KAKKAVERI POST, NAMAKKAL DISTRICT 637408",
      code: "2314",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "M KUMARASAMY COLLEGE OF ENGINEERING (AUTONOMOUS), THALAVAPALAYAM, KARUR DISTRICT 639113",
      code: "2608",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MAHENDRA ENGINEERING COLLEGE (AUTONOMOUS), MAHENDHIRAPURI, MALLASAMUDRAM, NAMAKKAL DISTRICT 637503",
      code: "2609",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "SRI RANGANATHAR INSTITUTE OF ENGINEERING AND TECHNOLOGY, THUDIALUR-KOVILPALAY ROAD, COIMBATORE DISTRICT 641110",
      code: "2342",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MUTHAYAMMAL ENGINEERING COLLEGE (AUTONOMOUS), RASIPURAM, NAMAKKAL DISTRICT 637408",
      code: "2610",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
      {
      name: "EASA COLLEGE OF ENGINEERING AND TECHNOLOGY, NH-47, COIMBATORE-PALAKKAD MAIN ROAD, NAVAKARAI POST, COIMBATORE DISTRICT 641105",
      code: "2749",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ROHINI COLLEGE OF ENGINEERING & TECHNOLOGY, ANJUGRAMAM-KANYAKUMARI MAIN ROAD, PALKULAM, VARIYOOR POST, KANYAKUMARI DISTRICT 629401",
      code: "4670",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "J C T COLLEGE OF ENGINEERING AND TECHNOLOGY, PICHANUR, COIMBATORE DISTRICT 641105",
      code: "2769",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PAAVAI ENGINEERING COLLEGE (AUTONOMOUS), NH-7, PACHAL POST, NAMAKKAL DISTRICT 637018",
      code: "2611",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MOHAMED SATHAK A J COLLEGE OF ENGINEERING, OLD MAHABALIPURAM ROAD (OMR), EGATTUR, CHENGALPATTU DISTRICT 603103",
      code: "1301",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K S R COLLEGE OF ENGINEERING (AUTONOMOUS), TIRUCHENGODE, NAMAKKAL DISTRICT 637215",
      code: "2613",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SENGUNTHAR ENGINEERING COLLEGE (AUTONOMOUS), TIRUCHENGODE, NAMAKKAL DISTRICT 637205",
      code: "2617",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P S N INSTITUTE OF TECHNOLOGY & SCIENCE, MELATHEDIYOOR, TIRUNELVELI DISTRICT 627152",
      code: "4949",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P S V COLLEGE OF ENGINEEERING AND TECHNOLOGY, MITTAPALLI, BALINAYANAPALLI POST, ELATHAGIRI, KRISHNAGIRI DISTRICT 635108",
      code: "2642",
      branch: "All Branches",
      location: "Krishnagiri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SENGUNTHAR COLLEGE OF ENGINEERING, TIRUCHENGODE, NAMAKKAL DISTRICT 637205",
      code: "2629",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "NANDHA COLLEGE OF TECHNOLOGY, PITCHANDAMPALAYAM POST, ERODE DISTRICT 638052",
      code: "2752",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "INFO INSTITUTE OF ENGINEERING, SARKAR SAMAKULAM, COIMBATORE DISTRICT 641107",
      code: "2732",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SONA COLLEGE OF TECHNOLOGY (AUTONOMOUS), SURAMANGALAM POST, SALEM DISTRICT 636005",
      code: "2618",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
      {
      name: "SRI MUTHUKUMARAN INSTITUTE OF TECHNOLOGY, NEAR MANGADU, CHENNAI 600069",
      code: "1218",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VIVEKANANDHA COLLEGE OF ENGINEERING FOR WOMEN (AUTONOMOUS), SATHINAICKENPALAYAM, ELAYAMPALAYAM VILLAGE, KUMARAMANGALAM, NAMAKKAL DISTRICT 637205",
      code: "2620",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "AAA COLLEGE OF ENGINEERING AND TECHNOLOGY, KAMARAJAR EDUCATIONAL ROAD, AMATHUR VILLAGE, SIVAKASI, VIRUDHUNAGAR DISTRICT 626005",
      code: "4680",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ER. PERUMAL MANIMEKALAI COLLEGE OF ENGINEERING, NEAR KONERIPALLI, HOSUR, KRISHNAGIRI DISTRICT 635117",
      code: "2621",
      branch: "All Branches",
      location: "Krishnagiri",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "SRI KRISHNA COLLEGE OF ENGINEERING, TIRUTTANI HIGH ROAD, ARAKKONAM, RANIPET DISTRICT 631003",
      code: "1526",
      branch: "All Branches",
      location: "Ranipet",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "V S B ENGINEERING COLLEGE, KOVAI ROAD, KARUR DISTRICT 639111",
      code: "2622",
      branch: "All Branches",
      location: "Karur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KINGS COLLEGE OF ENGINEERING, PUNALKULAM, PUDUKKOTTAI DISTRICT 613303",
      code: "3905",
      branch: "All Branches",
      location: "Pudukkottai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PARK INSTITUTE OF ARCHITECTURE, AVINASHI ROAD, NH-47, KANIYUR, COIMBATORE DISTRICT 641659",
      code: "2372",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "GNANAMANI COLLEGE OF TECHNOLOGY, PACHAL POST, NAMAKKAL DISTRICT 637018",
      code: "2624",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "R V S COLLEGE OF ENGINEERING AND TECHNOLOGY, KANNAMPALAYAM, SULUR, COIMBATORE DISTRICT 641402",
      code: "2731",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PARISUTHAM INSTITUTE OF TECHNOLOGY AND SCIENCE, RING ROAD, NANJIKOTTAI, THANJAVUR DISTRICT 613006",
      code: "3833",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DHANALAKSHMI COLLEGE OF ENGINEERING, MANIMANGALAM, CHENNAI 601301",
      code: "1405",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MAHENDRA INSTITUTE OF TECHNOLOGY, MAHENDHIRAPURI, MALLASAMUDRAM, NAMAKKAL DISTRICT 637503",
      code: "2632",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "EXCEL ENGINEERING COLLEGE, PALLAKKAPALAYAM, SANKARI WEST POST, NAMAKKAL DISTRICT 637303",
      code: "2634",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ANNAPORNA ENGINEERING COLLEGE, SANKARI MAIN ROAD, NH-47, PERIASEERAGAPADI, SALEM DISTRICT 636308",
      code: "2648",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "AL-AMEEN ENGINEERING COLLEGE, KARUNDEVAN PALAYAM, NANJAI UTHUKULI POST, ERODE DISTRICT 638104",
      code: "2652",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KNOWLEDGE INSTITUTE OF TECHNOLOGY, KIOT CAMPUS, KAKAPALAYAM POST, SALEM DISTRICT 637504",
      code: "2653",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "BANNARI AMMAN INSTITUTE OF TECHNOLOGY (AUTONOMOUS), SATHYAMANAGALAM, ERODE DISTRICT 638401",
      code: "2702",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "LOYOLA INSTITUTE OF TECHNOLOGY, MEVALOORKUPPAM, B VILLAGE, PALANCHOOR, NAZARETHPET POST, CHENNAI 600123",
      code: "1225",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "PERI INSTITUTE OF TECHNOLOGY, MANNIVAKKAM, WEST TAMBARAM, CHENGALPATTU DISTRICT, CHENNAI 600048",
      code: "1452",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "COIMBATORE INSTITUTE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), NARASIPURAM POST, COIMBATORE DISTRICT 641109",
      code: "2704",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DR. MAHALINGAM COLLEGE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), MACKINAICKENPATTI POST, POLLACHI TALUK, COIMBATORE DISTRICT 642003",
      code: "2706",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KARPAGAM INSTITUTE OF TECHNOLOGY, SEERAPALAYAM VILLAGE, L&T BY PASS ROAD, COIMBATORE DISTRICT 641021",
      code: "2735",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ERODE SENGUNTHAR ENGINEERING COLLEGE, THUDUPATHI POST, ERODE DISTRICT 638057",
      code: "2707",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ANAND INSTITUTE OF HIGHER TECHNOLOGY, OLD MAHABALIPURAM ROAD (OMR), KAZHIPATTUR, CHENGALPATTU DISTRICT 603103",
      code: "1303",
      branch: "All Branches",
      location: "Chengalpattu",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "HINDUSTHAN COLLEGE OF ENGINEERING AND TECHNOLOGY, OTHAKKALMANDAPAM POST, COIMBATORE DISTRICT 641032",
      code: "2708",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ROEVER ENGINEERING COLLEGE, ELAMBALUR, PERAMBALUR DISTRICT 621212",
      code: "3817",
      branch: "All Branches",
      location: "Perambalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "M I E T ENGINEERING COLLEGE, TRICHY-PUDUKKOTTAI ROAD, TIRUCHIRAPPALLI DISTRICT 620007",
      code: "3811",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KARPAGAM COLLEGE OF ENGINEERING (AUTONOMOUS), OTHAKKALMANDAPAM, COIMBATORE DISTRICT 641032",
      code: "2710",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KONGU ENGINEERING COLLEGE (AUTONOMOUS), PERUNDURAI, ERODE DISTRICT 638052",
      code: "2711",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PAAVAI COLLEGE OF TECHNOLOGY, NH-7, PACHAL POST, NAMAKKAL DISTRICT 637018",
      code: "2657",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SELVAM COLLEGE OF TECHNOLOGY, PAPPANAICKENPATTI POST, NAMAKKAL DISTRICT 637003",
      code: "2627",
      branch: "All Branches",
      location: "Namakkal",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KUMARAGURU COLLEGE OF TECHNOLOGY (AUTONOMOUS), CHINNAVEDAMPATTI POST, COIMBATORE DISTRICT 641006",
      code: "2712",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PARK COLLEGE OF ENGINEERING AND TECHNOLOGY, KANIYUR, COIMBATORE DISTRICT 641659",
      code: "2716",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KINGSTON ENGINEERING COLLEGE, CHITHOOR MAIN ROAD, CHRISTIANPET VILLAGE, KATPADI TALUK, VELLORE DISTRICT 632059",
      code: "1520",
      branch: "All Branches",
      location: "Vellore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "NANDHA ENGINEERING COLLEGE (AUTONOMOUS), PITCHANDAMPALAYAM POST, ERODE DISTRICT 638052",
      code: "2715",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI KRISHNA COLLEGE OF ENGINERING AND TECHNOLOGY (AUTONOMOUS), KUNIAMUTHUR, COIMBATORE DISTRICT 641008",
      code: "2718",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI RAMAKRISHNA ENGINEERING COLLEGE (AUTONOMOUS), VATTAMALAIPALAYAM, COIMBATORE DISTRICT 641022",
      code: "2719",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI KRISHNA COLLEGE OF TECHNOLOGY (AUTONOMOUS), KOVAIPUDUR POST, COIMBATORE DISTRICT 641042",
      code: "2722",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VELALAR COLLEGE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), THINDAL POST, ERODE DISTRICT 638009",
      code: "2723",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "SRI VENKATESWARA COLLEGE OF ENGINEERING AND TECHNOLOGY, THIRUPACHUR, THIRUVALLUR DISTRICT 631203",
      code: "1116",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "THE KAVERY ENGINEERING COLLEGE, M KALIPATTI POST, MECHERI, SALEM DISTRICT 634453",
      code: "2625",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "R V S EDUCATIONAL TRUST'S GROUPS OF INSTITUTIONS (INTEGRATED CAMPUS), N PARAIPATTI POST, VEDASANDUR TALUK, DINDIGUL DISTRICT 624005",
      code: "5862",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ADHI COLLEGE OF ENGINEERING AND TECHNOLOGY, PAZHAYASEEVARAM, MADURA SANKARAPURAM VILLAGE, KANCHEEPURAM DISTRICT 631605",
      code: "1233",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "PANIMALAR INSTITUTE OF TECHNOLOGY, NAZARETHPET, POONAMALLEE, CHENNAI 602103",
      code: "1231",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "JANSONS INSTITUTE OF TECHNOLOGY, KARUMATHAMPATTY, SOMAUR, COIMBATORE DISTRICT 641659",
      code: "2762",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI RAMAKRISHNA INSTITUTE OF TECHNOLOGY (AUTONOMOUS), PACHAPALAYAM, COIMBATORE DISTRICT 641010",
      code: "2725",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SNS COLLEGE OF TECHNOLOGY AUTONOMOUS, SNS KALVI NAGAR,SATHY MAIN ROAD , SARAVANAMPATTI POST, COIMBATORE DISTRICT 641035",
      code: "2726",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI SHAKTHI INSTITUTE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), L&T BYE-PASS, VENKITAPURAM POST, COMIBATORE DISTRICT 641062",
      code: "2727",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "S N S COLLEGE OF ENGINEERING, SATHY MAIN ROAD, KURUMBAPALAYAM POST, COIMBATORE DISTRICT 641107",
      code: "2734",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "INDRA GANESAN COLLEGE OF ENGINEERING, MADURAI MAIN ROAD, MANIKANDAM, TIRUCHIRAPPALLI DISTRICT 620012",
      code: "3831",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DHIRAJLAL GANDHI COLLEGE OF TECHNOLOGY, SIKKANAMPATTY, (OPP. TO AIRPORT), OMALUR TALUK, SALEM DISTRICT 636309",
      code: "2345",
      branch: "All Branches",
      location: "Salem",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DR. N G P INSTITUTE OF TECHNOLOGY, KALAPATTI ROAD, COIMBATORE DISTRICT 641035",
      code: "2736",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SRI ESHWAR COLLEGE OF ENGINEERING (AUTONOMOUS), KONDAMPATTI POST, VADASITHUR (VIA), KINATHUKADAVU, COIMBATORE DISTRICT 641202",
      code: "2739",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "HINDUSTAN INSTITUTE OF TECHNOLOGY, OTHAKKALMANDAPAM, COIMBATORE DISTRICT 641032",
      code: "2740",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P A COLLEGE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), PALLADAM ROAD, POLLACHI, COIMBATORE DISTRICT 642002",
      code: "2741",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SHREE VENKATESHWARA HI-TECH ENGINEERING COLLEGE, OTHAKUTHIRAI, K METTUPALAYAM POST, GOBICHETTIPALAYAM, ERODE DISTRICT 638455",
      code: "2747",
      branch: "All Branches",
      location: "Erode",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KIT-KALAIGNAR KARUNANIDHI INSTITUTE OF TECHNOLOGY (AUTONOMOUS), KANNAMPALAYAM, COIMBATORE DISTRICT 641402",
      code: "2750",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "UNITED INSTITUTE OF TECHNOLOGY, GADALORE VILLAGE, PERIANAICKENPALAYAM, COIMBATORE DISTRICT 641020",
      code: "2761",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "NEHRU INSTITUTE OF TECHNOLOGY, THIRUMALAYAMPALAYAM POST, COIMBATORE DISTRICT 641105",
      code: "2755",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "GRT INSTITUTE OF ENGINEERING AND TECHNOLOGY, GRT MAHALAKSHMI NAGAR, CHENNAI-TIRUPATHI HIGHWAY, TIRUTTANI TALUK, THIRUVALLUR DISTRICT 631209",
      code: "1238",
      branch: "All Branches",
      location: "Thiruvallur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
      {
      name: "DHAANISH AHMED COLLEGE OF ENGINEERING, PADAPPAI, CHENNAI 601301",
      code: "1424",
      branch: "All Branches",
      location: "Kancheepuram",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K P R INSTITUTE OF ENGINEERING AND TECHNOLOGY, KOLLUPALAYAM VILLAGE, ARASUR PANCHAYAT, COIMBATORE DISTRICT 641407",
      code: "2764",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "STELLA MARYS COLLEGE OF ENGINEERING, ARUNTHENGAN VILAI, AZHIKAL POST, KANYAKUMARI DISTRICT 629202",
      code: "4672",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K RAMAKRISHNAN COLLEGE OF TECHNOLOGY, KARIYAMANICKAM ROAD, SAMAYAPURAM, MANACHANALLUR TALUK, TIRUCHIRAPPALLI DISTRICT 621112",
      code: "3701",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "DHANALAKSHMI SRINIVASAN ENGINEERING COLLEGE, THURAIYUR ROAD, PERAMBALUR DISTRICT 621212",
      code: "3805",
      branch: "All Branches",
      location: "Perambalur",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "J J COLLEGE OF ENGINEERING AND TECHNOLOGY, POOLANKULATHUPATTI POST, THIRUCHIRAPPALLI DISTRICT 620009",
      code: "3807",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "EDAYATHANGUDI G S PILLAY ENGINEERING COLLEGE (AUTONOMOUS), NAGAPATTINAM DISTRICT 611002",
      code: "3806",
      branch: "All Branches",
      location: "Nagapattinam",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KONGUNADU COLLEGE OF ENGINEERING AND TECHNOLOGY, THOLURPATTI, THOTTIYAM, TIRUCHIRAPPALLI DISTRICT 621215",
      code: "3826",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K RAMAKRISHNAN COLLEGE OF ENGINEERING, KARIYAMANICKAM ROAD, SAMAYAPURAM, MANACHANALLUR TALUK, TIRUCHIRAPPALLI DISTRICT 621112",
      code: "3830",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "SETHU INSTITUTE OF TECHNOLOGY (AUTONOMOUS), KARIAPATTI POST, VIRUDHUNAGAR DISTRICT 626106",
      code: "4917",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "FRANCIS XAVIER ENGINEERING COLLEGE (AUTONOMOUS), VANNARPETTAI, TIRUNELVELI DISTRICT 627003",
      code: "4955",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "KAMARAJ COLLEGE OF ENGINEERING AND TECHNOLOGY, VIRUDHUNAGAR DISTRICT 626001",
      code: "4959",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "MEPCO SCHLENK ENGINEERING COLLEGE (AUTONOMOUS), SIVAKASI, VIRUDHUNAGAR DISTRICT 626005",
      code: "4960",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "NATIONAL ENGINEERING COLLEGE (AUTONOMOUS), KOVILPATTI, THOOTHUKUDI DISTRICT 628503",
      code: "4962",
      branch: "All Branches",
      location: "Thoothukudi",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P S N COLLEGE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS), MELATHEDIYOOR, TIRUNELVELI DSTRICT 627152",
      code: "4964",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P S R ENGINEERING COLLEGE (AUTONOMOUS), APPAYANAICKENPATTI, SEVALPATTI, VIRUDHUNAGAR DISTRICT 626140",
      code: "4965",
      branch: "All Branches",
      location: "Virudhunagar",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
     {
      name: "MEENAKSHI SUNDARARAJAN ENGINEERING COLLEGE, KODAMBAKKAM, CHENNAI 600024",
      code: "1309",
      branch: "All Branches",
      location: "Chennai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "ST. XAVIER CATHOLIC COLLEGE OF ENGINEERING, CHUNKANKADAI, NAGERCOIL, KANYAKUMARI DISTRICT 629807",
      code: "4971",
      branch: "All Branches",
      location: "Kanyakumari",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "N P R COLLEGE OF ENGINEERING AND TECHNOLOGY, NATHAM, DINDIGUL DISTRICT 624003",
      code: "5832",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "K L N COLLEGE OF ENGINEERING, POTTAPALAYAM, SIVAGANGAI DISTRICT 630611",
      code: "5904",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "P S N A COLLLEGE OF ENGINEERING AND TECHNOLOGY, DINDIGUL DISTRICT 624622",
      code: "5910",
      branch: "All Branches",
      location: "Dindigul",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    {
      name: "VELAMMAL COLLEGE OF ENGINEERING AND TECHNOLOGY, MADURAI - RAMESHWARAM HIGH ROAD, VIRAGANOOR, MADURAI DISTRICT 625009",
      code: "5986",
      branch: "All Branches",
      location: "Madurai",
      fees: "Contact college",
      duration: "4 years",
      placement: "N/A",
      type: "Autonomous"
    },
    // Tamil Nadu Government Engineering Colleges
    {
      name: "THANTHAI PERIYAR GOVERNMENT INSTITUTE OF TECHNOLOGY",
      code: "1516",
      branch: "All Branches",
      location: "Vellore",
      fees: "₹30,000 per year",
      duration: "4 years",
      placement: "₹5.5 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF TECHNOLOGY (AUTONOMOUS)",
      code: "2005",
      branch: "All Branches",
      location: "Coimbatore",
      fees: "₹25,000 per year",
      duration: "4 years",
      placement: "₹7.8 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING DHARMAPURI",
      code: "2369",
      branch: "All Branches",
      location: "Dharmapuri",
      fees: "₹28,000 per year",
      duration: "4 years",
      placement: "₹5.2 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING BARGUR (AUTONOMOUS)",
      code: "2603",
      branch: "All Branches",
      location: "Krishnagiri",
      fees: "₹26,000 per year",
      duration: "4 years",
      placement: "₹5.8 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING SALEM (AUTONOMOUS)",
      code: "2615",
      branch: "All Branches",
      location: "Salem",
      fees: "₹27,000 per year",
      duration: "4 years",
      placement: "₹6.2 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING ERODE",
      code: "2709",
      branch: "All Branches",
      location: "Erode",
      fees: "₹29,000 per year",
      duration: "4 years",
      placement: "₹5.5 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING THANJAVUR",
      code: "3464",
      branch: "All Branches",
      location: "Thanjavur",
      fees: "₹26,000 per year",
      duration: "4 years",
      placement: "₹5.9 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING SRIRANGAM",
      code: "3465",
      branch: "All Branches",
      location: "Tiruchirappalli",
      fees: "₹25,000 per year",
      duration: "4 years",
      placement: "₹6.5 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING TIRUNELVELI",
      code: "4974",
      branch: "All Branches",
      location: "Tirunelveli",
      fees: "₹28,000 per year",
      duration: "4 years",
      placement: "₹6.0 LPA average",
      type: "Government"
    },
    {
      name: "GOVERNMENT COLLEGE OF ENGINEERING BODINAYAKKANUR",
      code: "5009",
      branch: "All Branches",
      location: "Theni",
      fees: "₹27,000 per year",
      duration: "4 years",
      placement: "₹5.4 LPA average",
      type: "Government"
    },
    {
      name: "ALAGAPPA CHETTAIR GOVERNMENT COLLEGE OF ENGINEERING AND TECHNOLOGY (AUTONOMOUS)",
      code: "5901",
      branch: "All Branches",
      location: "Sivagangai",
      fees: "₹24,000 per year",
      duration: "4 years",
      placement: "₹6.8 LPA average",
      type: "Government"
    }
  ];

  const filteredColleges = colleges.filter(college => {
    const matchesType = selectedType === 'All' || college.type === selectedType;
    return matchesType;
  });

  // Pagination logic
  const pagination = usePagination({ data: filteredColleges, initialItemsPerPage: 25 });
  const currentColleges = pagination.currentItems;

  return (
  <div className="min-h-screen bg-gray-50">
    {/* Hero Section with Animated Slideshow Background */}
    <section className="relative text-white py-12 sm:py-16 overflow-hidden min-h-[400px]">
      <div className="absolute inset-0 w-full h-full z-0">
        <EngineeringSlideshowBackground />
      </div>
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Engineering Colleges Database
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white">
            Comprehensive list of engineering colleges with detailed information
          </p>
        </motion.div>
      </div>
    </section>

      {/* TNEA Admission Status Banner */}
    <div className="w-full bg-gradient-to-r from-red-600 via-orange-500 to-red-600 text-white py-4 overflow-hidden relative z-10 shadow-lg">
      <div className="absolute inset-0 bg-black/20"></div>
      <motion.div 
        className="whitespace-nowrap relative z-20 flex items-center"
        initial={{ x: "100vw" }}
        animate={{ x: "-100%" }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop"
        }}
      >
        <div className="flex items-center space-x-8 text-xl font-bold tracking-wide">
          <span>🚨 IMPORTANT: TNEA 2025 Admissions were closed on 15/09/2025</span>
          <span>•</span>
          <span>📞 For guidance on alternative admissions and next steps, contact our experts</span>
          <span>•</span>
          <span>🎓 We help you find the best alternative pathways</span>
          <span>•</span>
          <span>📱 Contact: +91 77086 77132 (Enquiry) | +91 93610 27132 (Advisor)</span>
          <span>•</span>
          <span>📧 Email: infonammasewa@gmail.com</span>
          <span>•</span>
        </div>
      </motion.div>
    </div>

    {/* College Type Filter Section */}
    <section className="py-6 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-3">Filter by College Type:</h3>
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
            {['All', 'Government', 'Central Government', 'Government Aided', 'Anna University Constituent', 'Autonomous', 'Non-Autonomous'].map((type) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={`px-3 py-2 text-xs sm:text-sm rounded-lg font-medium transition-colors truncate ${
                  selectedType === type
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
                title={type}
              >
                {type}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
      {/* Colleges Section */}
      <section className="py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 sm:mb-8 text-gray-900">
            Engineering Colleges
            {selectedType !== 'All' && ` (${selectedType})`}
          </h2>
          {/* Grid grouping removed; using table-only display */}
          
          {/* Results Summary */}
          <div className="text-center mb-6">
            <p className="text-gray-600 text-sm sm:text-base">
              Showing <span className="font-semibold text-blue-600">{pagination.startIndex + 1}-{Math.min(pagination.endIndex, filteredColleges.length)}</span> of <span className="font-semibold text-blue-600">{filteredColleges.length}</span> colleges
              {pagination.totalPages > 1 && (
                <span className="ml-2 text-sm text-gray-500">(Page {pagination.currentPage} of {pagination.totalPages})</span>
              )}
            </p>
          </div>
          
          {filteredColleges.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">No colleges found matching your criteria.</p>
            </div>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              {/* Desktop Table */}
              <div className="hidden lg:block overflow-x-auto">
                <table className="w-full table-auto">
                  <thead className="bg-blue-600 text-white">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold">College Name</th>
                      <th className="px-4 py-3 text-left font-semibold">College Code</th>
                      <th className="px-4 py-3 text-left font-semibold">Type</th>
                      <th className="px-4 py-3 text-left font-semibold">Location</th>
                      <th className="px-4 py-3 text-left font-semibold">Fees/Year</th>
                      <th className="px-4 py-3 text-left font-semibold">Avg Package</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {currentColleges.map((college, index) => (
                      <motion.tr
                        key={pagination.startIndex + index}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: (index % 10) * 0.05 }}
                        viewport={{ once: true }}
                        className={`border-b border-gray-200 hover:bg-gray-50 ${
                          (pagination.startIndex + index) % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                        }`}
                      >
                        <td className="px-4 py-4 text-sm font-medium text-gray-900">
                          {college.name}
                        </td>
                        <td className="px-4 py-4 text-sm font-mono text-blue-600 font-semibold">
                          {college.code}
                        </td>
                        <td className="px-4 py-4 text-sm">
                          <span className={`px-2 py-1 rounded text-xs font-medium ${
                            college.type === 'Government' 
                              ? 'bg-green-100 text-green-800'
                              : college.type === 'Autonomous'
                              ? 'bg-purple-100 text-purple-800'
                              : 'bg-pink-100 text-pink-800'
                          }`}>
                            {college.type}
                          </span>
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600">
                          {college.location}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-green-600">
                          {college.fees}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-blue-600">
                          {college.placement}
                        </td>
                        
                      </motion.tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card Layout */}
              <div className="lg:hidden">
                {currentColleges.map((college, index) => (
                  <motion.div
                    key={pagination.startIndex + index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: (index % 5) * 0.1 }}
                    viewport={{ once: true }}
                    className="border-b border-gray-200 p-4 hover:bg-gray-50"
                  >
                    <div className="space-y-3">
                      <div className="flex justify-between items-start">
                        <h3 className="font-semibold text-gray-900 text-sm leading-tight pr-2">
                          {college.name}
                        </h3>
                        <span className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap ${
                          college.type === 'Government' 
                            ? 'bg-green-100 text-green-800'
                            : college.type === 'Autonomous'
                            ? 'bg-purple-100 text-purple-800'
                            : 'bg-pink-100 text-pink-800'
                        }`}>
                          {college.type}
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-2 text-xs">
                        <div>
                          <span className="text-gray-500">Code:</span>
                          <span className="font-mono text-blue-600 font-semibold ml-1">{college.code}</span>
                        </div>
                        <div>
                          <span className="text-gray-500">Location:</span>
                          <span className="text-gray-700 ml-1">{college.location}</span>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-2 text-xs">
                        <div>
                          <span className="text-gray-500">Fees:</span>
                          <span className="text-green-600 font-medium ml-1">{college.fees}</span>
                        </div>
                        <div>
                          <span className="text-gray-500">Package:</span>
                          <span className="text-blue-600 font-medium ml-1">{college.placement}</span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )}

          {/* Pagination Controls */}
          {filteredColleges.length > 0 && (
            <PaginationControls
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              itemsPerPage={pagination.itemsPerPage}
              totalItems={filteredColleges.length}
              startIndex={pagination.startIndex}
              endIndex={pagination.endIndex}
              onNextPage={pagination.handleNextPage}
              onPrevPage={pagination.handlePrevPage}
              onItemsPerPageChange={pagination.setItemsPerPage}
              onPageChange={pagination.goToPage}
              className="mt-8"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default CollegesPage;








// Placement Percentage Information (Google Help)
// For most colleges, placement percentage varies from 60% to 95%. For IITs/NITs, it is often above 90%. For other colleges, please check the official website or Google for the latest placement percentage.
// Example:
// IIT Kharagpur: ~90%+
// NIT Trichy: ~92%
// DTU: ~85%
// Jadavpur University: ~80%
// For other colleges, placement percentage may not be available; use Google for up-to-date info.
